var items = {
  "block.minecraft.acacia_button": "Acacia Bọtịnụ",
  "block.minecraft.acacia_door": "Acacia Orzọ",
  "block.minecraft.acacia_fence": "Acacia ngere",
  "block.minecraft.acacia_fence_gate": "Ọnụ ụzọ ámá Acacia",
  "block.minecraft.acacia_hanging_sign": "Acacia Hanging Sign",
  "block.minecraft.acacia_leaves": "Acacia doo",
  "block.minecraft.acacia_log": "Abanye na Acacia",
  "block.minecraft.acacia_planks": "Acacia Atụmatụ",
  "block.minecraft.acacia_pressure_plate": "Plate Strike Acacia",
  "block.minecraft.acacia_sapling": "Acacia Sapling",
  "block.minecraft.acacia_shelf": "Acacia Shelf",
  "block.minecraft.acacia_sign": "Ama Acacia",
  "block.minecraft.acacia_slab": "Acacia Slab",
  "block.minecraft.acacia_stairs": "Acacia Nzọụkwụ",
  "block.minecraft.acacia_trapdoor": "Acacia Ahihia",
  "block.minecraft.acacia_wall_hanging_sign": "Acacia Wall Hanging Sign",
  "block.minecraft.acacia_wall_sign": "Ihe acacia acacia",
  "block.minecraft.acacia_wood": "Osisi Acacia",
  "block.minecraft.activator_rail": "Atorzọ Njikwa",
  "block.minecraft.air": "Ikuku",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Ihe mgbochi nke amethyst",
  "block.minecraft.amethyst_cluster": "Ụyọkọ Amethyst",
  "block.minecraft.ancient_debris": "Nkpọrọ ochie",
  "block.minecraft.andesite": "Andesite",
  "block.minecraft.andesite_slab": "Okpokoro Andesite",
  "block.minecraft.andesite_stairs": "Steepụ Andesite",
  "block.minecraft.andesite_wall": "Mgbidi Andesite",
  "block.minecraft.anvil": "Anvil",
  "block.minecraft.attached_melon_stem": "Egwu Na-etinye Ya",
  "block.minecraft.attached_pumpkin_stem": "Akpokọta Ugu",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Akwụkwọ Azalea",
  "block.minecraft.azure_bluet": "Azure Bluet",
  "block.minecraft.bamboo": "Achara",
  "block.minecraft.bamboo_block": "Ngọngọ nke achara",
  "block.minecraft.bamboo_button": "Bọtịnụ achara",
  "block.minecraft.bamboo_door": "Ambgba égbè",
  "block.minecraft.bamboo_fence": "Ngere achara",
  "block.minecraft.bamboo_fence_gate": "Ọnụ ụzọ ngere achara",
  "block.minecraft.bamboo_hanging_sign": "Bamboo Hanging Sign",
  "block.minecraft.bamboo_mosaic": "Bamboo Mosaic",
  "block.minecraft.bamboo_mosaic_slab": "Bamboo Mosaic Slab",
  "block.minecraft.bamboo_mosaic_stairs": "Bamboo Mosaic Stairs",
  "block.minecraft.bamboo_planks": "Bamboo Planks",
  "block.minecraft.bamboo_pressure_plate": "Bamboo Pressure Plate",
  "block.minecraft.bamboo_sapling": "Ambgba égbè",
  "block.minecraft.bamboo_shelf": "Bamboo Shelf",
  "block.minecraft.bamboo_sign": "Bamboo Sign",
  "block.minecraft.bamboo_slab": "Bamboo Slab",
  "block.minecraft.bamboo_stairs": "Bamboo Stairs",
  "block.minecraft.bamboo_trapdoor": "Bamboo Trapdoor",
  "block.minecraft.bamboo_wall_hanging_sign": "Bamboo Wall Hanging Sign",
  "block.minecraft.bamboo_wall_sign": "Bamboo Wall Sign",
  "block.minecraft.banner.base.black": "Ubi ojii zuru oke",
  "block.minecraft.banner.base.blue": "Ubi bluu zuru oke",
  "block.minecraft.banner.base.brown": "Ubi brawu zuru oke",
  "block.minecraft.banner.base.cyan": "Ubi cian zuru oke",
  "block.minecraft.banner.base.gray": "Ubi Grey zuru oke",
  "block.minecraft.banner.base.green": "Ubi griin zuru oke",
  "block.minecraft.banner.base.light_blue": "Ubi acha anụnụ anụnụ nke ọma",
  "block.minecraft.banner.base.light_gray": "Ubi ọkụ Grey zuru oke",
  "block.minecraft.banner.base.lime": "Ubi Lime zuru oke",
  "block.minecraft.banner.base.magenta": "Ubi magenta nke ọma",
  "block.minecraft.banner.base.orange": "Ubi epe nke ọma",
  "block.minecraft.banner.base.pink": "Ubi Pink zuru oke",
  "block.minecraft.banner.base.purple": "Ubi populu zuru oke",
  "block.minecraft.banner.base.red": "Ubi Uhie zuru ezu",
  "block.minecraft.banner.base.white": "Ubi ọcha nke ọma",
  "block.minecraft.banner.base.yellow": "Ubi edo edo zuru oke",
  "block.minecraft.banner.border.black": "Oke-ala ojii",
  "block.minecraft.banner.border.blue": "Oke-ala anụnụ anụnụ",
  "block.minecraft.banner.border.brown": "Oke-ala ájá ájá",
  "block.minecraft.banner.border.cyan": "Oke-ala ntụ ntụ",
  "block.minecraft.banner.border.gray": "Oke-ala ntụ ntụ",
  "block.minecraft.banner.border.green": "Oke-ala akwụkwọ ndụ akwụkwọ ndụ",
  "block.minecraft.banner.border.light_blue": "Oke-ala anụnụ anụnụ ìhè",
  "block.minecraft.banner.border.light_gray": "Oke-ala ntụ ntụ ìhè",
  "block.minecraft.banner.border.lime": "Oke-ala oroma nkịrịsị",
  "block.minecraft.banner.border.magenta": "Oke-ala uhieodo",
  "block.minecraft.banner.border.orange": "Oke-ala uhiedo",
  "block.minecraft.banner.border.pink": "Oke-ala uhie ocha",
  "block.minecraft.banner.border.purple": "Oke-ala odo odo",
  "block.minecraft.banner.border.red": "Oke-ala ọbara ọbara",
  "block.minecraft.banner.border.white": "Oke-ala ocha",
  "block.minecraft.banner.border.yellow": "Oke-ala edo edo",
  "block.minecraft.banner.bricks.black": "Etechiela Ubi ojii",
  "block.minecraft.banner.bricks.blue": "Etechiela ubi anụnụ anụnụ",
  "block.minecraft.banner.bricks.brown": "Etechiela ubi aja aja",
  "block.minecraft.banner.bricks.cyan": "Etechiela ubi ntụ ntụ",
  "block.minecraft.banner.bricks.gray": "Etechiela ubi ntụ ntụ",
  "block.minecraft.banner.bricks.green": "Etechiela ubi akwụkwọ ndụ akwụkwọ ndụ",
  "block.minecraft.banner.bricks.light_blue": "Etechiela ubi anụnụ anụnụ ìhè",
  "block.minecraft.banner.bricks.light_gray": "Etechiela ubi ntụ ntụ ìhè",
  "block.minecraft.banner.bricks.lime": "Etechiela ubi oroma nkịrịsị",
  "block.minecraft.banner.bricks.magenta": "Etechiela ubi uhieodo",
  "block.minecraft.banner.bricks.orange": "Etechiela ubi uhiedo",
  "block.minecraft.banner.bricks.pink": "Etechiela ubi uhie ọcha",
  "block.minecraft.banner.bricks.purple": "Etechiela ubi odo odo",
  "block.minecraft.banner.bricks.red": "Etechiela ubi ọbara ọbara",
  "block.minecraft.banner.bricks.white": "Etechiela ubi ọcha",
  "block.minecraft.banner.bricks.yellow": "Etechiela ubi edo edo",
  "block.minecraft.banner.circle.black": "Okirikiri Ojii",
  "block.minecraft.banner.circle.blue": "Blue Roundel",
  "block.minecraft.banner.circle.brown": "Brown Roundel",
  "block.minecraft.banner.circle.cyan": "Cyan Roundel",
  "block.minecraft.banner.circle.gray": "Grey Roundel",
  "block.minecraft.banner.circle.green": "block.minecraft.banner.circle.green",
  "block.minecraft.banner.circle.light_blue": "Ìhè Bulu Roundel",
  "block.minecraft.banner.circle.light_gray": "Light Gray Roundel",
  "block.minecraft.banner.circle.lime": "Lime Roundel",
  "block.minecraft.banner.circle.magenta": "Magenta Roundel",
  "block.minecraft.banner.circle.orange": "Oroma Roundel",
  "block.minecraft.banner.circle.pink": "Pink Roundel",
  "block.minecraft.banner.circle.purple": "Purple Roundel",
  "block.minecraft.banner.circle.red": "Roundel uhie",
  "block.minecraft.banner.circle.white": "Ọcha Roundel",
  "block.minecraft.banner.circle.yellow": "Yellow Roundel",
  "block.minecraft.banner.creeper.black": "Ego ịrị elu ojii",
  "block.minecraft.banner.creeper.blue": "Chaajị anụnụ anụnụ na-akpụ akpụ",
  "block.minecraft.banner.creeper.brown": "Chaajị aja aja na-akpụ akpụ",
  "block.minecraft.banner.creeper.cyan": "Chaajị ntụ ntụ na-akpụ akpụ",
  "block.minecraft.banner.creeper.gray": "Ụgwọ creeper isi awọ",
  "block.minecraft.banner.creeper.green": "Chaajị akwụkwọ ndụ akwụkwọ ndụ na-akpụ akpụ",
  "block.minecraft.banner.creeper.light_blue": "Chaajị anụnụ anụnụ ìhè na-akpụ akpụ",
  "block.minecraft.banner.creeper.light_gray": "Chaji ìhè ịrị elu isi awọ",
  "block.minecraft.banner.creeper.lime": "Chaajị oroma nkirisi na-akpụ akpụ",
  "block.minecraft.banner.creeper.magenta": "Chaajị uhieodo na-akpụ akpụ",
  "block.minecraft.banner.creeper.orange": "Chaajị uhiedo na-akpụ akpụ",
  "block.minecraft.banner.creeper.pink": "Ego ịrị elu pink",
  "block.minecraft.banner.creeper.purple": "Chaajị odo odo na-akpụ akpụ",
  "block.minecraft.banner.creeper.red": "Chaaji ọbara ọbara na- akpụ akpụ",
  "block.minecraft.banner.creeper.white": "Chaajị ọcha na-akpụ akpụ",
  "block.minecraft.banner.creeper.yellow": "Chaajị ede edo na-akpụ akpụ",
  "block.minecraft.banner.cross.black": "Nwa Nnu",
  "block.minecraft.banner.cross.blue": "Bulu Nnu",
  "block.minecraft.banner.cross.brown": "Agba aja Nnu",
  "block.minecraft.banner.cross.cyan": "Cyan Nnu",
  "block.minecraft.banner.cross.gray": "Grey Nnu",
  "block.minecraft.banner.cross.green": "Agba akwụkwọ ndụ Nnu",
  "block.minecraft.banner.cross.light_blue": "Uhie Bulu Nnu",
  "block.minecraft.banner.cross.light_gray": "Ìhè Agba ntụ Nnu",
  "block.minecraft.banner.cross.lime": "Wayo Nnu",
  "block.minecraft.banner.cross.magenta": "Magenta Nnu",
  "block.minecraft.banner.cross.orange": "Oroma Nnu",
  "block.minecraft.banner.cross.pink": "Pink Nnu",
  "block.minecraft.banner.cross.purple": "Pọpụl Salt",
  "block.minecraft.banner.cross.red": "Uhie Nnu",
  "block.minecraft.banner.cross.white": "Na-acha ọcha Nnu",
  "block.minecraft.banner.cross.yellow": "Edo edo edo",
  "block.minecraft.banner.curly_border.black": "Oke-ala ojii abaghị uru",
  "block.minecraft.banner.curly_border.blue": "Oke-ala anụnụ anụnụ abaghị uru",
  "block.minecraft.banner.curly_border.brown": "Oke-ala ájá ájá abaghị uru",
  "block.minecraft.banner.curly_border.cyan": "Oke-ala ntụ ntụ abaghị uru",
  "block.minecraft.banner.curly_border.gray": "Oke-ala ntụ ntụ abaghị uru",
  "block.minecraft.banner.curly_border.green": "Oke-ala akwụkwọ ndụ akwụkwọ ndụ abaghị uru",
  "block.minecraft.banner.curly_border.light_blue": "Oke-ala anụnụ anụnụ ìhè abaghị uru",
  "block.minecraft.banner.curly_border.light_gray": "Oke-ala ntụ ntụ ìhè abaghị uru",
  "block.minecraft.banner.curly_border.lime": "Oke-ala oroma nkịrịsị abaghị uru",
  "block.minecraft.banner.curly_border.magenta": "Oke-ala uhieodo abaghị uru",
  "block.minecraft.banner.curly_border.orange": "Oke-ala uhiedo abaghị uru",
  "block.minecraft.banner.curly_border.pink": "Oke-ala uhieọcha abaghị uru",
  "block.minecraft.banner.curly_border.purple": "Oke-ala odo odo abaghị uru",
  "block.minecraft.banner.curly_border.red": "Oke-ala ọbara ọbara abaghị uru",
  "block.minecraft.banner.curly_border.white": "Ocha Bordure abaghị uru",
  "block.minecraft.banner.curly_border.yellow": "Oke-ala edo edo abaghị uru",
  "block.minecraft.banner.diagonal_left.black": "Black Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.blue": "Blue Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.brown": "Brown Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.cyan": "Cyan Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.gray": "Grey Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.green": "Green Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.light_blue": "Ìhè Blue Kwa Bend Sinister",
  "block.minecraft.banner.diagonal_left.light_gray": "Ìhè Grey Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.lime": "Lime kwa Bend Sinister",
  "block.minecraft.banner.diagonal_left.magenta": "Magenta Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.orange": "Orange Kwa Bend Sinister",
  "block.minecraft.banner.diagonal_left.pink": "Pink Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.purple": "Purple Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.red": "Red Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.white": "White Per Bend Sinister",
  "block.minecraft.banner.diagonal_left.yellow": "Yellow Kwa Bend Sinister",
  "block.minecraft.banner.diagonal_right.black": "Black kwa band",
  "block.minecraft.banner.diagonal_right.blue": "Blue kwa band",
  "block.minecraft.banner.diagonal_right.brown": "Brown kwa band",
  "block.minecraft.banner.diagonal_right.cyan": "Cyan Kwa Bend",
  "block.minecraft.banner.diagonal_right.gray": "Awo kwa Bend",
  "block.minecraft.banner.diagonal_right.green": "Green kwa band",
  "block.minecraft.banner.diagonal_right.light_blue": "Oroma nkịrịsị Kwa Bend",
  "block.minecraft.banner.diagonal_right.light_gray": "Ìhè isi awọ kwa Bend",
  "block.minecraft.banner.diagonal_right.lime": "Oroma nkịrịsị Kwa Bend",
  "block.minecraft.banner.diagonal_right.magenta": "Magenta Kwa Bend",
  "block.minecraft.banner.diagonal_right.orange": "Oroma Kwa Bend",
  "block.minecraft.banner.diagonal_right.pink": "Pink Kwa Bend",
  "block.minecraft.banner.diagonal_right.purple": "Purple Kwa Bend",
  "block.minecraft.banner.diagonal_right.red": "Uhie kwa band",
  "block.minecraft.banner.diagonal_right.white": "Ọcha Kwa Bend",
  "block.minecraft.banner.diagonal_right.yellow": "Yelloe Kwa Bend",
  "block.minecraft.banner.diagonal_up_left.black": "Black Kwa Bend gbanwere",
  "block.minecraft.banner.diagonal_up_left.blue": "Blue Per Bend gbanwere",
  "block.minecraft.banner.diagonal_up_left.brown": "Agba agba agba agba aja aja agbajiri agbaji",
  "block.minecraft.banner.diagonal_up_left.cyan": "Cyan Kwa Bend na-agbanwe",
  "block.minecraft.banner.diagonal_up_left.gray": "Agba Grey gbagọrọ agbagọ",
  "block.minecraft.banner.diagonal_up_left.green": "Green Kwa Bend gbanwere",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Ìhè Blue kwa Bend gbanwere",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Ìhè Agba Agba Per Bendver",
  "block.minecraft.banner.diagonal_up_left.lime": "Wayo Kwa Bend gbanwere",
  "block.minecraft.banner.diagonal_up_left.magenta": "Magenta Kwa gbagọrọ agbagọ",
  "block.minecraft.banner.diagonal_up_left.orange": "Oroma Kwa Bend",
  "block.minecraft.banner.diagonal_up_left.pink": "Pink Kwa Bend gbanwere",
  "block.minecraft.banner.diagonal_up_left.purple": "A gbanwere Purple Per Bend",
  "block.minecraft.banner.diagonal_up_left.red": "Red Per Bend gbanwere",
  "block.minecraft.banner.diagonal_up_left.white": "White Kwa Bend gbanwere",
  "block.minecraft.banner.diagonal_up_left.yellow": "Yellow Nke Bend gbanwere",
  "block.minecraft.banner.diagonal_up_right.black": "Black Kwa Bend Sinister Agbanwe Agbanwe",
  "block.minecraft.banner.diagonal_up_right.blue": "> block.minecraft.banner.diagonal_up_right.blue",
  "block.minecraft.banner.diagonal_up_right.brown": "\nblock.minecraft.banner.diagonal_up_right.brown",
  "block.minecraft.banner.diagonal_up_right.cyan": "block.minecraft.banner.diagonal_up_right.cyan",
  "block.minecraft.banner.diagonal_up_right.gray": "block.minecraft.banner.diagonal_up_right.gray",
  "block.minecraft.banner.diagonal_up_right.green": "Akwụkwọ ndụ Kwa Bend Agbagharala mmehie",
  "block.minecraft.banner.diagonal_up_right.light_blue": "block.minecraft.banner.diagonal_up_right.light_blue",
  "block.minecraft.banner.diagonal_up_right.light_gray": "block.minecraft.banner.diagonal_up_right.light_gray",
  "block.minecraft.banner.diagonal_up_right.lime": "block.minecraft.banner.diagonal_up_right.lime",
  "block.minecraft.banner.diagonal_up_right.magenta": "block.minecraft.banner.diagonal_up_right.magenta",
  "block.minecraft.banner.diagonal_up_right.orange": "block.minecraft.banner.diagonal_up_right.orange",
  "block.minecraft.banner.diagonal_up_right.pink": "block.minecraft.banner.diagonal_up_right.pink",
  "block.minecraft.banner.diagonal_up_right.purple": "\n block.minecraft.banner.diagonal_up_right.purple",
  "block.minecraft.banner.diagonal_up_right.red": "Uhie Kwa Bend Agbagharala mmehie",
  "block.minecraft.banner.diagonal_up_right.white": "block.minecraft.banner.diagonal_up_right.white",
  "block.minecraft.banner.diagonal_up_right.yellow": " block.minecraft.banner.diagonal_up_right.yellow",
  "block.minecraft.banner.flow.black": "Black Flow",
  "block.minecraft.banner.flow.blue": "Blue Flow",
  "block.minecraft.banner.flow.brown": "Brown Flow",
  "block.minecraft.banner.flow.cyan": "Cyan Flow",
  "block.minecraft.banner.flow.gray": "Gray Flow",
  "block.minecraft.banner.flow.green": "Green Flow",
  "block.minecraft.banner.flow.light_blue": "Light Blue Flow",
  "block.minecraft.banner.flow.light_gray": "Light Gray Flow",
  "block.minecraft.banner.flow.lime": "Lime Flow",
  "block.minecraft.banner.flow.magenta": "Magenta Flow",
  "block.minecraft.banner.flow.orange": "Orange Flow",
  "block.minecraft.banner.flow.pink": "Pink Flow",
  "block.minecraft.banner.flow.purple": "Purple Flow",
  "block.minecraft.banner.flow.red": "Red Flow",
  "block.minecraft.banner.flow.white": "White Flow",
  "block.minecraft.banner.flow.yellow": "Yellow Flow",
  "block.minecraft.banner.flower.black": "Oji Ifuru Chaji",
  "block.minecraft.banner.flower.blue": "Chaajị okooko anụnụ anụnụ",
  "block.minecraft.banner.flower.brown": "Chaajị okooko aja aja",
  "block.minecraft.banner.flower.cyan": "Chaajị okooko ntụ ntụ",
  "block.minecraft.banner.flower.gray": "Chaajị okooko ntụ ntụ",
  "block.minecraft.banner.flower.green": "Nke-nke Ifuru Chaji",
  "block.minecraft.banner.flower.light_blue": "Chaajị okooko anụnụ anụnụ ìhè",
  "block.minecraft.banner.flower.light_gray": "Chaajị okooko ntụ ntụ ìhè",
  "block.minecraft.banner.flower.lime": "Chaajị okooko oroma nkịrịsị",
  "block.minecraft.banner.flower.magenta": "Chaajị okooko uhieodo",
  "block.minecraft.banner.flower.orange": "Chaajị okooko uhiedo",
  "block.minecraft.banner.flower.pink": "Chaajị okooko uhiedo",
  "block.minecraft.banner.flower.purple": "Chaajị okooko odo odo",
  "block.minecraft.banner.flower.red": "Mme mme Ifuru Chaji",
  "block.minecraft.banner.flower.white": "Chaajị okooko ọcha",
  "block.minecraft.banner.flower.yellow": "Chaajị okooko edo edo",
  "block.minecraft.banner.globe.black": "Oji ụwa",
  "block.minecraft.banner.globe.blue": "Bulu ụwa",
  "block.minecraft.banner.globe.brown": "Uri ụwa",
  "block.minecraft.banner.globe.cyan": "Cyan ụwa",
  "block.minecraft.banner.globe.gray": "Grey ụwa",
  "block.minecraft.banner.globe.green": "Nke-nke ụwa",
  "block.minecraft.banner.globe.light_blue": "Ìhè Bulu ụwa",
  "block.minecraft.banner.globe.light_gray": "Ìhè Grey ụwa",
  "block.minecraft.banner.globe.lime": "Ìhè Nke-nke ụwa",
  "block.minecraft.banner.globe.magenta": "Magenta ụwa",
  "block.minecraft.banner.globe.orange": "Oroma ụwa",
  "block.minecraft.banner.globe.pink": "Uhie Ocha ụwa",
  "block.minecraft.banner.globe.purple": "Acha ozo ozo ụwa",
  "block.minecraft.banner.globe.red": "Mme mme ụwa",
  "block.minecraft.banner.globe.white": "Ocha ụwa",
  "block.minecraft.banner.globe.yellow": "Edo ụwa",
  "block.minecraft.banner.gradient.black": "Oji grajentị",
  "block.minecraft.banner.gradient.blue": "Bulu grajentị",
  "block.minecraft.banner.gradient.brown": "Uri grajentị",
  "block.minecraft.banner.gradient.cyan": "Cyan grajentị",
  "block.minecraft.banner.gradient.gray": "Grey grajentị",
  "block.minecraft.banner.gradient.green": "Ndu-ndu grajentị",
  "block.minecraft.banner.gradient.light_blue": "Ìhè bulu grajentị",
  "block.minecraft.banner.gradient.light_gray": "Ìhè grey grajentị",
  "block.minecraft.banner.gradient.lime": "Ìhè Nke-nke grajentị",
  "block.minecraft.banner.gradient.magenta": "Magenta grajentị",
  "block.minecraft.banner.gradient.orange": "Oroma grajentị",
  "block.minecraft.banner.gradient.pink": "Uhie ocha grajentị",
  "block.minecraft.banner.gradient.purple": "Acha odo odo grajentị",
  "block.minecraft.banner.gradient.red": "Uhie grajentị",
  "block.minecraft.banner.gradient.white": "Ocha grajentị",
  "block.minecraft.banner.gradient.yellow": "Edo grajentị",
  "block.minecraft.banner.gradient_up.black": "Oji Isi grajentị",
  "block.minecraft.banner.gradient_up.blue": "Bulu Isi grajentị",
  "block.minecraft.banner.gradient_up.brown": "Uri Isi grajentị",
  "block.minecraft.banner.gradient_up.cyan": "Cyan Isi grajentị",
  "block.minecraft.banner.gradient_up.gray": "Grey Isi grajentị",
  "block.minecraft.banner.gradient_up.green": "Nke-nke Isi grajentị",
  "block.minecraft.banner.gradient_up.light_blue": "Ìhè Bulu Isi grajentị",
  "block.minecraft.banner.gradient_up.light_gray": "Ìhè Grey Isi grajentị",
  "block.minecraft.banner.gradient_up.lime": "Ìhè Nke-nke Isi grajentị",
  "block.minecraft.banner.gradient_up.magenta": "Magenta Isi grajentị",
  "block.minecraft.banner.gradient_up.orange": "Oroma Isi grajentị",
  "block.minecraft.banner.gradient_up.pink": "Uhie ocha Isi grajentị",
  "block.minecraft.banner.gradient_up.purple": "Acha ozo ozo Isi grajentị",
  "block.minecraft.banner.gradient_up.red": "Mme mme Isi grajentị",
  "block.minecraft.banner.gradient_up.white": "Ocha Isi grajentị",
  "block.minecraft.banner.gradient_up.yellow": "Edo Isi grajentị",
  "block.minecraft.banner.guster.black": "Black Guster",
  "block.minecraft.banner.guster.blue": "Blue Guster",
  "block.minecraft.banner.guster.brown": "Brown Guster",
  "block.minecraft.banner.guster.cyan": "Cyan Guster",
  "block.minecraft.banner.guster.gray": "Gray Guster",
  "block.minecraft.banner.guster.green": "Green Guster",
  "block.minecraft.banner.guster.light_blue": "Light Blue Guster",
  "block.minecraft.banner.guster.light_gray": "Light Gray Guster",
  "block.minecraft.banner.guster.lime": "Lime Guster",
  "block.minecraft.banner.guster.magenta": "Magenta Guster",
  "block.minecraft.banner.guster.orange": "Orange Guster",
  "block.minecraft.banner.guster.pink": "Pink Guster",
  "block.minecraft.banner.guster.purple": "Purple Guster",
  "block.minecraft.banner.guster.red": "Red Guster",
  "block.minecraft.banner.guster.white": "White Guster",
  "block.minecraft.banner.guster.yellow": "Yellow Guster",
  "block.minecraft.banner.half_horizontal.black": "Nwa Per Per",
  "block.minecraft.banner.half_horizontal.blue": "Bulu Kwa Fess",
  "block.minecraft.banner.half_horizontal.brown": "Uri Kwa Fess",
  "block.minecraft.banner.half_horizontal.cyan": "Cyan Kwa Fess",
  "block.minecraft.banner.half_horizontal.gray": "Grey Kwa Fess",
  "block.minecraft.banner.half_horizontal.green": "Green Per Fess",
  "block.minecraft.banner.half_horizontal.light_blue": "Ìhè Bulu Kwa Fess",
  "block.minecraft.banner.half_horizontal.light_gray": "Ìhè Grey Kwa Fess",
  "block.minecraft.banner.half_horizontal.lime": "Ìhè Ndu-ndu Kwa Fess",
  "block.minecraft.banner.half_horizontal.magenta": "Magenta Kwa Fess",
  "block.minecraft.banner.half_horizontal.orange": "Oroma Kwa Fess",
  "block.minecraft.banner.half_horizontal.pink": "Uhie ocha Kwa Fess",
  "block.minecraft.banner.half_horizontal.purple": "Acha odo odo Kwa Fess",
  "block.minecraft.banner.half_horizontal.red": "Red Per Fess",
  "block.minecraft.banner.half_horizontal.white": "Ocha Kwa Fess",
  "block.minecraft.banner.half_horizontal.yellow": "Edo Kwa Fess",
  "block.minecraft.banner.half_horizontal_bottom.black": "Black Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Acha anụnụ anụnụ maka ntụgharị Fess",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brown Maka Fess tụgharịa",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cyan Per Fess tụgharịrị",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Atụgharịrị Grey Per Fess",
  "block.minecraft.banner.half_horizontal_bottom.green": "Green Maka Fess tụgharịa",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Atụgharịrị na-acha anụnụ anụnụ kwa Fess",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Agbanyụrụ agba ntụ kwa Fess",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Tụgharịa wayo kwa Fess",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Magenta kwa Fess tụgharịrị",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oroma Kwa Fess tụgharịa",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Pink kwa Fess tụgharịrị",
  "block.minecraft.banner.half_horizontal_bottom.purple": "A tụgharịala odo odo kwa nkọ",
  "block.minecraft.banner.half_horizontal_bottom.red": "Red Per Fess Inverted",
  "block.minecraft.banner.half_horizontal_bottom.white": "Atụgharịrị na-acha ọcha kwa Fess",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Agbarụrụ Yellow Kwa Fess",
  "block.minecraft.banner.half_vertical.black": "Oji Kwa Icha",
  "block.minecraft.banner.half_vertical.blue": "Bulu Kwa Icha",
  "block.minecraft.banner.half_vertical.brown": "Uri Kwa Icha",
  "block.minecraft.banner.half_vertical.cyan": "Cyan Kwa Icha",
  "block.minecraft.banner.half_vertical.gray": "Grey Kwa Icha",
  "block.minecraft.banner.half_vertical.green": "Ndu-ndu Kwa Icha",
  "block.minecraft.banner.half_vertical.light_blue": "Blue na -acha ọcha na -acha",
  "block.minecraft.banner.half_vertical.light_gray": "Ìhè Grey Kwa Icha",
  "block.minecraft.banner.half_vertical.lime": "Wayo Kwa Pale",
  "block.minecraft.banner.half_vertical.magenta": "Magenta Per Pale",
  "block.minecraft.banner.half_vertical.orange": "Orange Kwa Icha",
  "block.minecraft.banner.half_vertical.pink": "Pink Kwa Pale",
  "block.minecraft.banner.half_vertical.purple": "Acha odo odo Kwa Icha",
  "block.minecraft.banner.half_vertical.red": "Uhie Kwa Icha",
  "block.minecraft.banner.half_vertical.white": "White Kwa Icha",
  "block.minecraft.banner.half_vertical.yellow": "Yellow Kwa Pale",
  "block.minecraft.banner.half_vertical_right.black": "Oji Kwa Icha Nke ozo",
  "block.minecraft.banner.half_vertical_right.blue": "Bulu Kwa Icha Nke ozo",
  "block.minecraft.banner.half_vertical_right.brown": "Uri Kwa Icha Nke ozo",
  "block.minecraft.banner.half_vertical_right.cyan": "Cyan Kwa Icha Nke ozo",
  "block.minecraft.banner.half_vertical_right.gray": "Gray Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.green": "Ndu-ndu Kwa Icha Nke ozo",
  "block.minecraft.banner.half_vertical_right.light_blue": "Light Blue Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.light_gray": "Ìhè Grey Kwa Icha Nke ozo",
  "block.minecraft.banner.half_vertical_right.lime": "Wayo kwa icha mmirimmiri tụgharịa",
  "block.minecraft.banner.half_vertical_right.magenta": "Magenta Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.orange": "Orange Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.pink": "Pink kwa Icha mmirimmiri tụgharịa",
  "block.minecraft.banner.half_vertical_right.purple": "Acha odo odo Kwa Icha Nke ozo",
  "block.minecraft.banner.half_vertical_right.red": "Uhie Kwa Icha Nke ozo",
  "block.minecraft.banner.half_vertical_right.white": "White Per Pale Inverted",
  "block.minecraft.banner.half_vertical_right.yellow": "Agbarụrụ Yellow Kwa Icha mmirimmiri",
  "block.minecraft.banner.mojang.black": "Oji apụl",
  "block.minecraft.banner.mojang.blue": "Bulu apụl",
  "block.minecraft.banner.mojang.brown": "Uri apụl",
  "block.minecraft.banner.mojang.cyan": "Cyan apụl",
  "block.minecraft.banner.mojang.gray": "Grey apụl",
  "block.minecraft.banner.mojang.green": "Nke-Nke apụl",
  "block.minecraft.banner.mojang.light_blue": "Ìhè Bulu apụl",
  "block.minecraft.banner.mojang.light_gray": "Ìhè Grey apụl",
  "block.minecraft.banner.mojang.lime": "Ìhè Nke-nke apụl",
  "block.minecraft.banner.mojang.magenta": "Magenta apụl",
  "block.minecraft.banner.mojang.orange": "Oroma apụl",
  "block.minecraft.banner.mojang.pink": "Uhie ocha apụl",
  "block.minecraft.banner.mojang.purple": "Acha ozo ozo",
  "block.minecraft.banner.mojang.red": "Mme mme apụl",
  "block.minecraft.banner.mojang.white": "Ocha apụl",
  "block.minecraft.banner.mojang.yellow": "Edo Ìhè Grey apụl",
  "block.minecraft.banner.piglin.black": "Oji Imi",
  "block.minecraft.banner.piglin.blue": "Acha anụnụ imi",
  "block.minecraft.banner.piglin.brown": "Sunaụtụ aja aja",
  "block.minecraft.banner.piglin.cyan": "Sunaụtụ ntụ ntụ",
  "block.minecraft.banner.piglin.gray": "Sunaụtụ ntụ ntụ",
  "block.minecraft.banner.piglin.green": "Sunaụtụ akwụkwọ ndụ akwụkwọ ndụ",
  "block.minecraft.banner.piglin.light_blue": "Sunaụtụ anụnụ anụnụ ìhè",
  "block.minecraft.banner.piglin.light_gray": "Sunaụtụ ntụ ntụ ìhè",
  "block.minecraft.banner.piglin.lime": "Sunaụtụ oroma nkịrịsị",
  "block.minecraft.banner.piglin.magenta": "Sunaụtụ uhieodo",
  "block.minecraft.banner.piglin.orange": "Sunaụtụ uhiedo",
  "block.minecraft.banner.piglin.pink": "Sunaụtụ uhieọcha",
  "block.minecraft.banner.piglin.purple": "Sunaụtụ odo odo",
  "block.minecraft.banner.piglin.red": "Uhie imi",
  "block.minecraft.banner.piglin.white": "Sunaụtụ ọcha",
  "block.minecraft.banner.piglin.yellow": "Èdò imi",
  "block.minecraft.banner.rhombus.black": "Oji Lozenge",
  "block.minecraft.banner.rhombus.blue": "Blue Lozenge",
  "block.minecraft.banner.rhombus.brown": "Uri Lozenge",
  "block.minecraft.banner.rhombus.cyan": "Cyan Lozenge",
  "block.minecraft.banner.rhombus.gray": "Gray Lozenge",
  "block.minecraft.banner.rhombus.green": "Ndu-ndu Lozenge",
  "block.minecraft.banner.rhombus.light_blue": "Ìhè Bulu Lozenge",
  "block.minecraft.banner.rhombus.light_gray": "Ìhè Grey Lozenge",
  "block.minecraft.banner.rhombus.lime": "Lime Lozenge",
  "block.minecraft.banner.rhombus.magenta": "Magenta Lozenge",
  "block.minecraft.banner.rhombus.orange": "Oroma lozenge",
  "block.minecraft.banner.rhombus.pink": "Uhie ocha Lozenge",
  "block.minecraft.banner.rhombus.purple": "Purple Lozenge",
  "block.minecraft.banner.rhombus.red": "Red Lozenge",
  "block.minecraft.banner.rhombus.white": "Ocha Lozenge",
  "block.minecraft.banner.rhombus.yellow": "Yellow Lozenge",
  "block.minecraft.banner.skull.black": "Oji Okpokoro isi Chaji",
  "block.minecraft.banner.skull.blue": "Bulu Okpokoro isi Chaji",
  "block.minecraft.banner.skull.brown": "Uri Okpokoro isi Chaji",
  "block.minecraft.banner.skull.cyan": "Cyan Okpokoro isi Chaji",
  "block.minecraft.banner.skull.gray": "Grey Okpokoro isi Chaji",
  "block.minecraft.banner.skull.green": "Nke-nke Okpokoro isi Chaji",
  "block.minecraft.banner.skull.light_blue": "Ìhè Bulu Okpokoro isi Chaji",
  "block.minecraft.banner.skull.light_gray": "Ìhè Grey Okpokoro isi Chaji",
  "block.minecraft.banner.skull.lime": "Ìhè Nke-nke Okpokoro isi Chaji",
  "block.minecraft.banner.skull.magenta": "Magenta Okpokoro isi Chaji",
  "block.minecraft.banner.skull.orange": "Oroma Okpokoro isi Chaji",
  "block.minecraft.banner.skull.pink": "Uhie ocha Okpokoro isi Chaji",
  "block.minecraft.banner.skull.purple": "Acha ozo ozo Okpokoro isi Chaji",
  "block.minecraft.banner.skull.red": "Mme mme Okpokoro isi Chaji",
  "block.minecraft.banner.skull.white": "Ocha Okpokoro isi Chaji",
  "block.minecraft.banner.skull.yellow": "Edo Okpokoro isi Chaji",
  "block.minecraft.banner.small_stripes.black": "Nwa Paly",
  "block.minecraft.banner.small_stripes.blue": "Bulu Paly",
  "block.minecraft.banner.small_stripes.brown": "Agba aja aja",
  "block.minecraft.banner.small_stripes.cyan": "Cyan Paly",
  "block.minecraft.banner.small_stripes.gray": "Grey Paly",
  "block.minecraft.banner.small_stripes.green": "Agba akwụkwọ ndụ Paly",
  "block.minecraft.banner.small_stripes.light_blue": "Ìhè Bulu Paly",
  "block.minecraft.banner.small_stripes.light_gray": "Ìhè Grey Paly",
  "block.minecraft.banner.small_stripes.lime": "Wayo Paly",
  "block.minecraft.banner.small_stripes.magenta": "Magenta Paly",
  "block.minecraft.banner.small_stripes.orange": "Oroma Paly",
  "block.minecraft.banner.small_stripes.pink": "Pink Paly",
  "block.minecraft.banner.small_stripes.purple": "Pọpụl Paly",
  "block.minecraft.banner.small_stripes.red": "Uhie Paly",
  "block.minecraft.banner.small_stripes.white": "Na-acha ọcha Paly",
  "block.minecraft.banner.small_stripes.yellow": "Edo-edo Paly",
  "block.minecraft.banner.square_bottom_left.black": "Nwa Isi Dexter Kantọn",
  "block.minecraft.banner.square_bottom_left.blue": "Bulu Isi Dexter Kantọn",
  "block.minecraft.banner.square_bottom_left.brown": "Agba aja aja Dexter Kantọn",
  "block.minecraft.banner.square_bottom_left.cyan": "Isi Cyan Dexter Cyan",
  "block.minecraft.banner.square_bottom_left.gray": "Agba ntụ ntụ Dexter Kantọn",
  "block.minecraft.banner.square_bottom_left.green": "Agba akwụkwọ ndụ Isi Dexter Kantọn",
  "block.minecraft.banner.square_bottom_left.light_blue": "Ìhè Bulu Base Dexter Kantọn",
  "block.minecraft.banner.square_bottom_left.light_gray": "Ìhè Agba ntụ Isi Dexter Kantọn",
  "block.minecraft.banner.square_bottom_left.lime": "Wayo Isi Dexter Kantọn",
  "block.minecraft.banner.square_bottom_left.magenta": "Magenta Isi Dexter Kantọn",
  "block.minecraft.banner.square_bottom_left.orange": "Oroma Isi Dexter Kantọn",
  "block.minecraft.banner.square_bottom_left.pink": "Pink Isi Dexter Kantọn",
  "block.minecraft.banner.square_bottom_left.purple": "Pọpụl Ntọala Dexter Kantọn",
  "block.minecraft.banner.square_bottom_left.red": "Uhie Uhie Dexter Kantọn",
  "block.minecraft.banner.square_bottom_left.white": "Na-acha ọcha Isi Dexter Kantọn",
  "block.minecraft.banner.square_bottom_left.yellow": "Edo-edo Isi Dexter Kantọn",
  "block.minecraft.banner.square_bottom_right.black": "Nwa Isi Sinister Kantọn",
  "block.minecraft.banner.square_bottom_right.blue": "Bulu Isi Sinister Kantọn",
  "block.minecraft.banner.square_bottom_right.brown": "Agba aja isi Sinister Kantọn",
  "block.minecraft.banner.square_bottom_right.cyan": "Cyan Isi Sinister Kantọn",
  "block.minecraft.banner.square_bottom_right.gray": "Grey Isi Sinister Kantọn",
  "block.minecraft.banner.square_bottom_right.green": "Agba akwụkwọ ndụ Isi Sinister Kantọn",
  "block.minecraft.banner.square_bottom_right.light_blue": "Ìhè Bulu Isi Sinister Kantọn",
  "block.minecraft.banner.square_bottom_right.light_gray": "Ìhè Agba ntụ Isi Sinister Kantọn",
  "block.minecraft.banner.square_bottom_right.lime": "Wayo Isi Sinister Kantọn",
  "block.minecraft.banner.square_bottom_right.magenta": "Magenta Isi Sinister Kantọn",
  "block.minecraft.banner.square_bottom_right.orange": "Oroma Isi Sinister Kantọn",
  "block.minecraft.banner.square_bottom_right.pink": "Pink Isi Sinister Kantọn",
  "block.minecraft.banner.square_bottom_right.purple": "Pledị Ihe Omume Dị Mpụ na Pọpụl",
  "block.minecraft.banner.square_bottom_right.red": "Uhie Isi Sinister Kantọn",
  "block.minecraft.banner.square_bottom_right.white": "Na-acha ọcha Isi Sinister Kantọn",
  "block.minecraft.banner.square_bottom_right.yellow": "Edo-edo Isi Sinister Kantọn",
  "block.minecraft.banner.square_top_left.black": "Onye isi ojii Dexter Kantọn",
  "block.minecraft.banner.square_top_left.blue": "Bulu Onyeisi Dexter Kantọn",
  "block.minecraft.banner.square_top_left.brown": "Agba aja Onyeisi Dexter Kantọn",
  "block.minecraft.banner.square_top_left.cyan": "Cyan Onyeisi Dexter Kantọn",
  "block.minecraft.banner.square_top_left.gray": "Agba ntụ Onyeisi Dexter Kantọn",
  "block.minecraft.banner.square_top_left.green": "Agba akwụkwọ ndụ Onyeisi Dexter Kantọn",
  "block.minecraft.banner.square_top_left.light_blue": "Ìhè Bulu Onyeisi Dexter Kantọn",
  "block.minecraft.banner.square_top_left.light_gray": "Ìhè Agba ntụ Onyeisi Dexter Kantọn",
  "block.minecraft.banner.square_top_left.lime": "Wayo Onyeisi Dexter Kantọn",
  "block.minecraft.banner.square_top_left.magenta": "Magenta Onyeisi Dexter Kantọn",
  "block.minecraft.banner.square_top_left.orange": "Oroma Onyeisi Dexter Kantọn",
  "block.minecraft.banner.square_top_left.pink": "Pink Onyeisi Dexter Kantọn",
  "block.minecraft.banner.square_top_left.purple": "Onye na-acha odo odo Onyeisi Dexter Kantọn",
  "block.minecraft.banner.square_top_left.red": "Uhie Onyeisi Dexter Kantọn",
  "block.minecraft.banner.square_top_left.white": "Na-acha ọcha Onyeisi Dexter Kantọn",
  "block.minecraft.banner.square_top_left.yellow": "Edo-edo Onyeisi Dexter Kantọn",
  "block.minecraft.banner.square_top_right.black": "Onye isi ojii Sinister Kantọn",
  "block.minecraft.banner.square_top_right.blue": "Bulu Onyeisi Sinister Kantọn",
  "block.minecraft.banner.square_top_right.brown": "Agba aja Onyeisi Sinister Kantọn",
  "block.minecraft.banner.square_top_right.cyan": "Cyan Onyeisi Sinister Kantọn",
  "block.minecraft.banner.square_top_right.gray": "Agba ntụ Onyeisi Sinister Kantọn",
  "block.minecraft.banner.square_top_right.green": "Agba akwụkwọ ndụ Onyeisi Sinister Kantọn",
  "block.minecraft.banner.square_top_right.light_blue": "Ìhè Bulu Onyeisi Sinister Kantọn",
  "block.minecraft.banner.square_top_right.light_gray": "Ìhè Agba ntụ Onyeisi Sinister Kantọn",
  "block.minecraft.banner.square_top_right.lime": "Wayo Onyeisi Sinister Kantọn",
  "block.minecraft.banner.square_top_right.magenta": "Magenta Onyeisi Sinister Kantọn",
  "block.minecraft.banner.square_top_right.orange": "Oroma Onyeisi Sinister Kantọn",
  "block.minecraft.banner.square_top_right.pink": "Pink Onyeisi Sinister Kantọn",
  "block.minecraft.banner.square_top_right.purple": "Pọpụl Onyeisi Sinister Kantọn",
  "block.minecraft.banner.square_top_right.red": "Uhie Onyeisi Sinister Kantọn",
  "block.minecraft.banner.square_top_right.white": "Na-acha ọcha Onyeisi Sinister Kantọn",
  "block.minecraft.banner.square_top_right.yellow": "Edo-edo Onyeisi Sinister Kantọn",
  "block.minecraft.banner.straight_cross.black": "Oji Obe",
  "block.minecraft.banner.straight_cross.blue": "Bulu Obe",
  "block.minecraft.banner.straight_cross.brown": "Uri Obe",
  "block.minecraft.banner.straight_cross.cyan": "Cyan Obe",
  "block.minecraft.banner.straight_cross.gray": "Grey Obe",
  "block.minecraft.banner.straight_cross.green": "Nke-nke Obe",
  "block.minecraft.banner.straight_cross.light_blue": "Ìhè Bulu Obe",
  "block.minecraft.banner.straight_cross.light_gray": "Ìhè Grey Obe",
  "block.minecraft.banner.straight_cross.lime": "Ìhè Nke-nke Obe",
  "block.minecraft.banner.straight_cross.magenta": "Magenta Obe",
  "block.minecraft.banner.straight_cross.orange": "Oroma Obe",
  "block.minecraft.banner.straight_cross.pink": "Mme mme Obe",
  "block.minecraft.banner.straight_cross.purple": "Acha ozo ozo Obe",
  "block.minecraft.banner.straight_cross.red": "Mme mme Obe",
  "block.minecraft.banner.straight_cross.white": "Ocha Obe",
  "block.minecraft.banner.straight_cross.yellow": "Edo Obe",
  "block.minecraft.banner.stripe_bottom.black": "Isi Oji",
  "block.minecraft.banner.stripe_bottom.blue": "Isi Bulu",
  "block.minecraft.banner.stripe_bottom.brown": "Isi Oyi",
  "block.minecraft.banner.stripe_bottom.cyan": "Isi Cyan",
  "block.minecraft.banner.stripe_bottom.gray": "Isi awọ",
  "block.minecraft.banner.stripe_bottom.green": "Isi Oyi",
  "block.minecraft.banner.stripe_bottom.light_blue": "Ìhè Bulu Isi",
  "block.minecraft.banner.stripe_bottom.light_gray": "Ìhè Isi awọ",
  "block.minecraft.banner.stripe_bottom.lime": "Wayo Isi",
  "block.minecraft.banner.stripe_bottom.magenta": "Magenta Isi",
  "block.minecraft.banner.stripe_bottom.orange": "Isi oroma",
  "block.minecraft.banner.stripe_bottom.pink": "Isi Pink",
  "block.minecraft.banner.stripe_bottom.purple": "Ntọala Pọpụl",
  "block.minecraft.banner.stripe_bottom.red": "Isi Uhie",
  "block.minecraft.banner.stripe_bottom.white": "Na-acha ọcha isi",
  "block.minecraft.banner.stripe_bottom.yellow": "Isi Edo-edo",
  "block.minecraft.banner.stripe_center.black": "Oji Oji",
  "block.minecraft.banner.stripe_center.blue": "Acha anụnụ anụnụ",
  "block.minecraft.banner.stripe_center.brown": "Agba aja aja",
  "block.minecraft.banner.stripe_center.cyan": "Cyan icha mmirimmiri",
  "block.minecraft.banner.stripe_center.gray": "Agba Grey",
  "block.minecraft.banner.stripe_center.green": "Agba akwụkwọ ndụ icha mmirimmiri",
  "block.minecraft.banner.stripe_center.light_blue": "Ìhè Bulu icha mmirimmiri",
  "block.minecraft.banner.stripe_center.light_gray": "Ìhè Agba Grey",
  "block.minecraft.banner.stripe_center.lime": "Wayo Icha",
  "block.minecraft.banner.stripe_center.magenta": "Magenta icha mmirimmiri",
  "block.minecraft.banner.stripe_center.orange": "Oroma icha mmirimmiri",
  "block.minecraft.banner.stripe_center.pink": "Pink icha mmirimmiri",
  "block.minecraft.banner.stripe_center.purple": "Agba odo",
  "block.minecraft.banner.stripe_center.red": "Uhie uhie",
  "block.minecraft.banner.stripe_center.white": "Na-acha ọcha Icha mmirimmiri",
  "block.minecraft.banner.stripe_center.yellow": "Acha odo odo",
  "block.minecraft.banner.stripe_downleft.black": "Nwa gbagọrọ agbagọ Sinister",
  "block.minecraft.banner.stripe_downleft.blue": "Bulu Gbagọrọ agbagọ Sinister",
  "block.minecraft.banner.stripe_downleft.brown": "Agba aja Gbagọrọ agbagọ Sinister",
  "block.minecraft.banner.stripe_downleft.cyan": "Cyan Gbagọrọ agbagọ Sinister",
  "block.minecraft.banner.stripe_downleft.gray": "Grey Gbagọrọ agbagọ Sinister",
  "block.minecraft.banner.stripe_downleft.green": "Agba akwụkwọ ndụ Gbagọrọ agbagọ Sinister",
  "block.minecraft.banner.stripe_downleft.light_blue": "Ìhè Bulu Gbagọrọ agbagọ Sinister",
  "block.minecraft.banner.stripe_downleft.light_gray": "Ìhè Grey gbagọrọ agbagọ Sinister",
  "block.minecraft.banner.stripe_downleft.lime": "Wayo Gbagọrọ agbagọ Sinister",
  "block.minecraft.banner.stripe_downleft.magenta": "Magenta Gbagọrọ agbagọ Sinister",
  "block.minecraft.banner.stripe_downleft.orange": "Oroma Gbagọrọ agbagọ Sinister",
  "block.minecraft.banner.stripe_downleft.pink": "Pink Gbagọrọ agbagọ Sinister",
  "block.minecraft.banner.stripe_downleft.purple": "Pọpụl gbagọrọ agbagọ Sinister",
  "block.minecraft.banner.stripe_downleft.red": "Uhie Uhie Gbagọrọ agbagọ Sinister",
  "block.minecraft.banner.stripe_downleft.white": "Na-acha ọcha Gbagọrọ agbagọ Sinister",
  "block.minecraft.banner.stripe_downleft.yellow": "Edo-edo Gbagọrọ agbagọ Sinister",
  "block.minecraft.banner.stripe_downright.black": "Nwa gbagọrọ agbagọ",
  "block.minecraft.banner.stripe_downright.blue": "Agba Gbagọrọ agbagọ",
  "block.minecraft.banner.stripe_downright.brown": "Agba agbagọ",
  "block.minecraft.banner.stripe_downright.cyan": "Cyan gbagọrọ agbagọ",
  "block.minecraft.banner.stripe_downright.gray": "Isi awọ",
  "block.minecraft.banner.stripe_downright.green": "Agba akwụkwọ ndụ Gbagọrọ agbagọ",
  "block.minecraft.banner.stripe_downright.light_blue": "Ìhè Bulu Gbagọrọ agbagọ",
  "block.minecraft.banner.stripe_downright.light_gray": "Ìhè Grey gbagọrọ agbagọ",
  "block.minecraft.banner.stripe_downright.lime": "Wayo gbagọrọ agbagọ",
  "block.minecraft.banner.stripe_downright.magenta": "Magenta Gbagọrọ agbagọ",
  "block.minecraft.banner.stripe_downright.orange": "Oroma Gbagọrọ agbagọ",
  "block.minecraft.banner.stripe_downright.pink": "Pink gbagọọ agbagọ",
  "block.minecraft.banner.stripe_downright.purple": "Pọpụl gbagọrọ agbagọ",
  "block.minecraft.banner.stripe_downright.red": "Uhie Uhie",
  "block.minecraft.banner.stripe_downright.white": "Na-acha ọcha Gbagọrọ agbagọ",
  "block.minecraft.banner.stripe_downright.yellow": "Edo edo edo",
  "block.minecraft.banner.stripe_left.black": "Nwa icha mmirimmiri Dexter",
  "block.minecraft.banner.stripe_left.blue": "Acha anụnụ anụnụ Dexter",
  "block.minecraft.banner.stripe_left.brown": "Agba aja Icha mmirimmiri Dexter",
  "block.minecraft.banner.stripe_left.cyan": "Cyan icha mmachi Dexter",
  "block.minecraft.banner.stripe_left.gray": "Agba ntụ Na-acha odo odo",
  "block.minecraft.banner.stripe_left.green": "Agba akwụkwọ ndụ Icha mmirimmiri Dexter",
  "block.minecraft.banner.stripe_left.light_blue": "Ìhè Bulu icha mmirimmiri Dexter",
  "block.minecraft.banner.stripe_left.light_gray": "Ìhè Grey Ichapu Dexter",
  "block.minecraft.banner.stripe_left.lime": "Wayo Wayo Dexter",
  "block.minecraft.banner.stripe_left.magenta": "Magenta icha mmirimmiri Dexter",
  "block.minecraft.banner.stripe_left.orange": "Oroma icha mmirimmiri Dexter",
  "block.minecraft.banner.stripe_left.pink": "Pink icha mmirimmiri Dexter",
  "block.minecraft.banner.stripe_left.purple": "Acha acha odo odo",
  "block.minecraft.banner.stripe_left.red": "Uhie Na-acha uhie uhie",
  "block.minecraft.banner.stripe_left.white": "Ọcha Na-acha ọcha Dexter",
  "block.minecraft.banner.stripe_left.yellow": "Edo-edo icha mmirimmiri Dexter",
  "block.minecraft.banner.stripe_middle.black": "Nwa Nwa",
  "block.minecraft.banner.stripe_middle.blue": "Bulu Fes",
  "block.minecraft.banner.stripe_middle.brown": "Agba aja aja",
  "block.minecraft.banner.stripe_middle.cyan": "Cyan Fes",
  "block.minecraft.banner.stripe_middle.gray": "Isi awọ",
  "block.minecraft.banner.stripe_middle.green": "Esgwọ Agba akwụkwọ ndụ",
  "block.minecraft.banner.stripe_middle.light_blue": "Ìhè Bulu Fes",
  "block.minecraft.banner.stripe_middle.light_gray": "Ìhè Isi awọ",
  "block.minecraft.banner.stripe_middle.lime": "Wayo Fes",
  "block.minecraft.banner.stripe_middle.magenta": "Magenta Fes",
  "block.minecraft.banner.stripe_middle.orange": "Oroma Fes",
  "block.minecraft.banner.stripe_middle.pink": "Pink agba",
  "block.minecraft.banner.stripe_middle.purple": "Akwukwo Udo",
  "block.minecraft.banner.stripe_middle.red": "Uhie uhie",
  "block.minecraft.banner.stripe_middle.white": "Na-acha ọcha Fes",
  "block.minecraft.banner.stripe_middle.yellow": "Odo odo",
  "block.minecraft.banner.stripe_right.black": "Oji Oji",
  "block.minecraft.banner.stripe_right.blue": "Bulu Icha mmirimmiri Sinister",
  "block.minecraft.banner.stripe_right.brown": "Agba aja Icha mmirimmiri Sinister",
  "block.minecraft.banner.stripe_right.cyan": "Cyan Icha mmirimmiri Sinister",
  "block.minecraft.banner.stripe_right.gray": "Agba Grey Icha mmirimmiri Sinister",
  "block.minecraft.banner.stripe_right.green": "Agba akwụkwọ ndụ Bilie Sinister",
  "block.minecraft.banner.stripe_right.light_blue": "Ìhè Bulu icha mmirimmiri Sinister",
  "block.minecraft.banner.stripe_right.light_gray": "Ìhè Na-acha uhie uhie Ihie",
  "block.minecraft.banner.stripe_right.lime": "Wayo",
  "block.minecraft.banner.stripe_right.magenta": "Magenta icha mmirimmiri Sinister",
  "block.minecraft.banner.stripe_right.orange": "Oroma icha mmirimmiri Sinister",
  "block.minecraft.banner.stripe_right.pink": "Pink icha mmirimmiri Sinister",
  "block.minecraft.banner.stripe_right.purple": "Achịcha Na-acha odo odo",
  "block.minecraft.banner.stripe_right.red": "Uhie Na-acha uhie uhie",
  "block.minecraft.banner.stripe_right.white": "Ọcha Na-acha Ọcha",
  "block.minecraft.banner.stripe_right.yellow": "Onye na-acha odo odo",
  "block.minecraft.banner.stripe_top.black": "Onye Isi Oji",
  "block.minecraft.banner.stripe_top.blue": "Bulu Onyeisi",
  "block.minecraft.banner.stripe_top.brown": "Agba aja Onyeisi",
  "block.minecraft.banner.stripe_top.cyan": "Onyeisi Cyan",
  "block.minecraft.banner.stripe_top.gray": "Isi awọ",
  "block.minecraft.banner.stripe_top.green": "Agba akwụkwọ ndụ Onyeisi",
  "block.minecraft.banner.stripe_top.light_blue": "Ìhè Bulu Onyeisi",
  "block.minecraft.banner.stripe_top.light_gray": "Ìhè Isi awọ",
  "block.minecraft.banner.stripe_top.lime": "Wayo Isi",
  "block.minecraft.banner.stripe_top.magenta": "Magenta Onyeisi",
  "block.minecraft.banner.stripe_top.orange": "oroma Onyeisi",
  "block.minecraft.banner.stripe_top.pink": "Pink Onyeisi",
  "block.minecraft.banner.stripe_top.purple": "Onyeisi Udo",
  "block.minecraft.banner.stripe_top.red": "Onyeisi Uhie",
  "block.minecraft.banner.stripe_top.white": "Na-acha ọcha Onyeisi",
  "block.minecraft.banner.stripe_top.yellow": "Onye Isi Edo-edo",
  "block.minecraft.banner.triangle_bottom.black": "Nwa Chevron",
  "block.minecraft.banner.triangle_bottom.blue": "Bulu Chevron",
  "block.minecraft.banner.triangle_bottom.brown": "Agba aja Chevron",
  "block.minecraft.banner.triangle_bottom.cyan": "Cyan Chevron",
  "block.minecraft.banner.triangle_bottom.gray": "Grey Chevron",
  "block.minecraft.banner.triangle_bottom.green": "Agba akwụkwọ ndụ Chevron",
  "block.minecraft.banner.triangle_bottom.light_blue": "Ìhè Bulu Chevron",
  "block.minecraft.banner.triangle_bottom.light_gray": "Ìhè Agba ntụ Chevron",
  "block.minecraft.banner.triangle_bottom.lime": "Wayo Chevron",
  "block.minecraft.banner.triangle_bottom.magenta": "Magenta Chevron",
  "block.minecraft.banner.triangle_bottom.orange": "Oroma Chevron",
  "block.minecraft.banner.triangle_bottom.pink": "Pink Chevron",
  "block.minecraft.banner.triangle_bottom.purple": "Pọpụl Chevron",
  "block.minecraft.banner.triangle_bottom.red": "Uhie Chevron",
  "block.minecraft.banner.triangle_bottom.white": "Na-acha ọcha Chevron",
  "block.minecraft.banner.triangle_bottom.yellow": "Edo-edo Chevron",
  "block.minecraft.banner.triangle_top.black": "Nwa Chegharịrị Nwa",
  "block.minecraft.banner.triangle_top.blue": "Bulu Chegharịrị Chevron",
  "block.minecraft.banner.triangle_top.brown": "Agba aja gbanwere Chevron",
  "block.minecraft.banner.triangle_top.cyan": "Cyan nọchiri Chevron",
  "block.minecraft.banner.triangle_top.gray": "Agba ntụ nọchiri Chevron",
  "block.minecraft.banner.triangle_top.green": "Agba akwụkwọ ndụ nọdụ Chevron",
  "block.minecraft.banner.triangle_top.light_blue": "Ìhè Blue Agbanwee Chevron",
  "block.minecraft.banner.triangle_top.light_gray": "Ìhè Na-agbanwe agbanwe Chevron",
  "block.minecraft.banner.triangle_top.lime": "Wayo na-agbanwe agbanwe Chevron",
  "block.minecraft.banner.triangle_top.magenta": "Agba akwụkwọ ndụ nọdụ Chevron",
  "block.minecraft.banner.triangle_top.orange": "Cyan nọchiri Chevron",
  "block.minecraft.banner.triangle_top.pink": "Pink nọchiri Chevron",
  "block.minecraft.banner.triangle_top.purple": "Chevron na-acha odo odo",
  "block.minecraft.banner.triangle_top.red": "Uhie Chegharịrị Chevron",
  "block.minecraft.banner.triangle_top.white": "Wayo na-agbanwe agbanwe Chevron",
  "block.minecraft.banner.triangle_top.yellow": "Nwa Chegharịrị Nwa",
  "block.minecraft.banner.triangles_bottom.black": "Isi Ejiri Oji",
  "block.minecraft.banner.triangles_bottom.blue": "Isi ihe na-acha anụnụ anụnụ",
  "block.minecraft.banner.triangles_bottom.brown": "Isi ala agba aja aja",
  "block.minecraft.banner.triangles_bottom.cyan": "Isi Cyan",
  "block.minecraft.banner.triangles_bottom.gray": "Isi awọ",
  "block.minecraft.banner.triangles_bottom.green": "Ejiri Green Base",
  "block.minecraft.banner.triangles_bottom.light_blue": "Ìhè Bulu icha mmirimmiri Dexter",
  "block.minecraft.banner.triangles_bottom.light_gray": "Light isi awọ Base Indented",
  "block.minecraft.banner.triangles_bottom.lime": "Wayo isi ala",
  "block.minecraft.banner.triangles_bottom.magenta": "Magenta Isi Indented",
  "block.minecraft.banner.triangles_bottom.orange": "Orange Isi Indented",
  "block.minecraft.banner.triangles_bottom.pink": "Pink Isi Indented",
  "block.minecraft.banner.triangles_bottom.purple": "Ihe Odide Purple",
  "block.minecraft.banner.triangles_bottom.red": "Isi Ejiri Oji",
  "block.minecraft.banner.triangles_bottom.white": "Isi ihe eji acha ọcha",
  "block.minecraft.banner.triangles_bottom.yellow": "Isi Yellow Base",
  "block.minecraft.banner.triangles_top.black": "Onye Isi Oji",
  "block.minecraft.banner.triangles_top.blue": "Onye isi na -acha anụnụ anụnụ",
  "block.minecraft.banner.triangles_top.brown": "Onye isi Brown agbakwunyere",
  "block.minecraft.banner.triangles_top.cyan": "Onye isi Cyan",
  "block.minecraft.banner.triangles_top.gray": "A nabatara onye isi awọ",
  "block.minecraft.banner.triangles_top.green": "Green Chief Indented",
  "block.minecraft.banner.triangles_top.light_blue": "Etinyere Blue Light",
  "block.minecraft.banner.triangles_top.light_gray": "A nabatara onye isi ọkụ ọkụ",
  "block.minecraft.banner.triangles_top.lime": "Wayo Chief Indented",
  "block.minecraft.banner.triangles_top.magenta": "Onye isi Magenta abatala",
  "block.minecraft.banner.triangles_top.orange": "Orange Chief Indented",
  "block.minecraft.banner.triangles_top.pink": "Onye isi Pink agbakwunyere",
  "block.minecraft.banner.triangles_top.purple": "A na -etinye Purple Chief",
  "block.minecraft.banner.triangles_top.red": "Onye Isi Uhie",
  "block.minecraft.banner.triangles_top.white": "A nabatara White Chief",
  "block.minecraft.banner.triangles_top.yellow": "Onye isi odo na -abata",
  "block.minecraft.barrel": "Gbọmgbọm",
  "block.minecraft.barrier": "Ihe mgbochi",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Ogidi",
  "block.minecraft.beacon.primary": "Ike Ike",
  "block.minecraft.beacon.secondary": "Secondary Ike",
  "block.minecraft.bed.no_sleep": "Can nwere ike ihi ụra n’abalị ma ọ bụ n’oge oke ikuku",
  "block.minecraft.bed.not_safe": "Ị nwere ike izu ike ugbu a; e nwere nnukwu anụ dị nso",
  "block.minecraft.bed.obstructed": "Ihe ndina a mechiri emechi",
  "block.minecraft.bed.occupied": "Ihe ndina a ka ji",
  "block.minecraft.bed.too_far_away": "Ị nwere ike izu ike ugbu a; ihe ndina dị nnọọ anya",
  "block.minecraft.bedrock": "Bedrock",
  "block.minecraft.bee_nest": "Bee akwu",
  "block.minecraft.beehive": "Bee",
  "block.minecraft.beetroots": "Beetroots",
  "block.minecraft.bell": "Mgbịrịgba",
  "block.minecraft.big_dripleaf": "Nnukwu Dripleaf",
  "block.minecraft.big_dripleaf_stem": "Nnukwu Stepleaf Stem",
  "block.minecraft.birch_button": "Birch Bọtịnụ",
  "block.minecraft.birch_door": "Ọrịa Birch",
  "block.minecraft.birch_fence": "Birch ngere",
  "block.minecraft.birch_fence_gate": "Ọnụ encezọ encemá Birch",
  "block.minecraft.birch_hanging_sign": "Birch Hanging Sign",
  "block.minecraft.birch_leaves": "Nnukwu Birch",
  "block.minecraft.birch_log": "Abanye na Birch",
  "block.minecraft.birch_planks": "Birch Atụmatụ",
  "block.minecraft.birch_pressure_plate": "Plate Strip Press",
  "block.minecraft.birch_sapling": "Birch Sapling",
  "block.minecraft.birch_shelf": "Birch Shelf",
  "block.minecraft.birch_sign": "Akara Birch",
  "block.minecraft.birch_slab": "Brich Slab",
  "block.minecraft.birch_stairs": "Birch Nzọụkwụ",
  "block.minecraft.birch_trapdoor": "Birch Ahihia",
  "block.minecraft.birch_wall_hanging_sign": "Birch Wall Hanging Sign",
  "block.minecraft.birch_wall_sign": "Ihe akara Birch",
  "block.minecraft.birch_wood": "Osisi Birch",
  "block.minecraft.black_banner": "Nwa Pụrụ Iche",
  "block.minecraft.black_bed": "Nwa ndina",
  "block.minecraft.black_candle": "Kandụl ojii",
  "block.minecraft.black_candle_cake": "Achicha na Black kandụl",
  "block.minecraft.black_carpet": "Kapeeti ojii",
  "block.minecraft.black_concrete": "Nwa ihe",
  "block.minecraft.black_concrete_powder": "Nwa lhe ntụ ntụ",
  "block.minecraft.black_glazed_terracotta": "Black na-egbuke egbuke Terracotta",
  "block.minecraft.black_shulker_box": "Igbe Black Shulker",
  "block.minecraft.black_stained_glass": "Ibe ojii",
  "block.minecraft.black_stained_glass_pane": "Nwa Agba Glass",
  "block.minecraft.black_terracotta": "Nwa Terracotta",
  "block.minecraft.black_wool": "Nwa Nwa ojii",
  "block.minecraft.blackstone": "Nwa ojii",
  "block.minecraft.blackstone_slab": "Blackstone Slab",
  "block.minecraft.blackstone_stairs": "Owu ojii",
  "block.minecraft.blackstone_wall": "Nwa Nkịtị",
  "block.minecraft.blast_furnace": "Gbawara Ọkụ",
  "block.minecraft.blue_banner": "Bulu Pụrụ Iche",
  "block.minecraft.blue_bed": "Bulu bed",
  "block.minecraft.blue_candle": "Kandụl na -acha anụnụ anụnụ",
  "block.minecraft.blue_candle_cake": "Achịcha na kandụl na -acha anụnụ anụnụ",
  "block.minecraft.blue_carpet": "Epeepe na-acha anụnụ anụnụ",
  "block.minecraft.blue_concrete": "Bulu Concrete",
  "block.minecraft.blue_concrete_powder": "Bulu lhe Ntụ ntụ",
  "block.minecraft.blue_glazed_terracotta": "Blue Glazed Terracotta",
  "block.minecraft.blue_ice": "Blue Ice",
  "block.minecraft.blue_orchid": "Blue Orchid",
  "block.minecraft.blue_shulker_box": "Igbe Blue Shulker",
  "block.minecraft.blue_stained_glass": "Ihu na-acha anụnụ anụnụ",
  "block.minecraft.blue_stained_glass_pane": "Igwe eji agba agba agba aja aja",
  "block.minecraft.blue_terracotta": "Blue Terracotta",
  "block.minecraft.blue_wool": "Blue ajị",
  "block.minecraft.bone_block": "Ọkpụkpụ Block",
  "block.minecraft.bookshelf": "Akwụkwọ akwụkwọ",
  "block.minecraft.brain_coral": "Coral ụbụrụ",
  "block.minecraft.brain_coral_block": "Oghere nke coral ụbụrụ",
  "block.minecraft.brain_coral_fan": "A na-enwe coral ụbụrụ",
  "block.minecraft.brain_coral_wall_fan": "Inbụrụ Coral Mgbidi Fan",
  "block.minecraft.brewing_stand": "Ime biya Guzosie",
  "block.minecraft.brick_slab": "Biriiki Slab",
  "block.minecraft.brick_stairs": "Brik steepụ",
  "block.minecraft.brick_wall": "Mgbidi brik\n",
  "block.minecraft.bricks": "Nkume eji arụ ụlọ",
  "block.minecraft.brown_banner": "Agba aja Pụrụ Iche",
  "block.minecraft.brown_bed": "Agba aja aja",
  "block.minecraft.brown_candle": "Candle Brown",
  "block.minecraft.brown_candle_cake": "Achịcha na kandụl aja aja",
  "block.minecraft.brown_carpet": "Kaadị aja aja",
  "block.minecraft.brown_concrete": "Agba aja Ihe",
  "block.minecraft.brown_concrete_powder": "Agba aja lhu Ntụ ntụ",
  "block.minecraft.brown_glazed_terracotta": "Agba aja aja Glazed Terracotta",
  "block.minecraft.brown_mushroom": "Brown Ero",
  "block.minecraft.brown_mushroom_block": "Brown Ero Mgbochi",
  "block.minecraft.brown_shulker_box": "Igwe Blue Shulker",
  "block.minecraft.brown_stained_glass": "Gilasi Brown",
  "block.minecraft.brown_stained_glass_pane": "Agba aja aja gbara agba",
  "block.minecraft.brown_terracotta": "Brown Terracotta",
  "block.minecraft.brown_wool": "Blue ajị",
  "block.minecraft.bubble_column": "Nkeji edemede",
  "block.minecraft.bubble_coral": "Coral egosipụta",
  "block.minecraft.bubble_coral_block": "Oghere nke coral egosipụta",
  "block.minecraft.bubble_coral_fan": "A na-enwe coral egosipụta",
  "block.minecraft.bubble_coral_wall_fan": "Afọ Coral Wall Fan",
  "block.minecraft.budding_amethyst": "Amethyst na -agba agba",
  "block.minecraft.bush": "Bush",
  "block.minecraft.cactus": "Kaktus",
  "block.minecraft.cactus_flower": "Cactus Flower",
  "block.minecraft.cake": "Achicha",
  "block.minecraft.calcite": "Gbakọọ",
  "block.minecraft.calibrated_sculk_sensor": "Calibrated Sculk Sensor",
  "block.minecraft.campfire": "Ogwe ọkụ",
  "block.minecraft.candle": "Kandụl",
  "block.minecraft.candle_cake": "Achicha na kandụl",
  "block.minecraft.carrots": "Carọt",
  "block.minecraft.cartography_table": "Ihe nkiri Isiokwu",
  "block.minecraft.carved_pumpkin": "Ebube a kụrụ akpụ",
  "block.minecraft.cauldron": "Cauldron",
  "block.minecraft.cave_air": "Igwe ikpuchi",
  "block.minecraft.cave_vines": "Osisi Vaịn",
  "block.minecraft.cave_vines_plant": "Osisi Osisi Cave",
  "block.minecraft.chain": "Chain",
  "block.minecraft.chain_command_block": "Chain Command Block",
  "block.minecraft.cherry_button": "Cherry Button",
  "block.minecraft.cherry_door": "Cherry Door",
  "block.minecraft.cherry_fence": "Cherry Fence",
  "block.minecraft.cherry_fence_gate": "Cherry Fence Gate",
  "block.minecraft.cherry_hanging_sign": "Cherry Hanging Sign",
  "block.minecraft.cherry_leaves": "Cherry Leaves",
  "block.minecraft.cherry_log": "Cherry Log",
  "block.minecraft.cherry_planks": "Cherry Planks",
  "block.minecraft.cherry_pressure_plate": "Cherry Pressure Plate",
  "block.minecraft.cherry_sapling": "Cherry Sapling",
  "block.minecraft.cherry_shelf": "Cherry Shelf",
  "block.minecraft.cherry_sign": "Cherry Sign",
  "block.minecraft.cherry_slab": "Cherry Slab",
  "block.minecraft.cherry_stairs": "Cherry Stairs",
  "block.minecraft.cherry_trapdoor": "Cherry Trapdoor",
  "block.minecraft.cherry_wall_hanging_sign": "Cherry Wall Hanging Sign",
  "block.minecraft.cherry_wall_sign": "Cherry Wall Sign",
  "block.minecraft.cherry_wood": "Cherry Wood",
  "block.minecraft.chest": "Igbe",
  "block.minecraft.chipped_anvil": "Anvil Kwadoro",
  "block.minecraft.chiseled_bookshelf": "Chiseled Bookshelf",
  "block.minecraft.chiseled_copper": "Chiseled Copper",
  "block.minecraft.chiseled_deepslate": "Deepzọ nke Chiseled",
  "block.minecraft.chiseled_nether_bricks": "Chiseled Nether Brick",
  "block.minecraft.chiseled_polished_blackstone": "Chiseled Polished Blackstone",
  "block.minecraft.chiseled_quartz_block": "Chiseled Quartz Block",
  "block.minecraft.chiseled_red_sandstone": "Chiseled Red Sandstone",
  "block.minecraft.chiseled_resin_bricks": "Chiseled Resin Bricks",
  "block.minecraft.chiseled_sandstone": "Chiseled Sandstone",
  "block.minecraft.chiseled_stone_bricks": "Chiseled Nkume brik",
  "block.minecraft.chiseled_tuff": "Chiseled Tuff",
  "block.minecraft.chiseled_tuff_bricks": "Chiseled Tuff Bricks",
  "block.minecraft.chorus_flower": "Chorus Ifuru",
  "block.minecraft.chorus_plant": "Osisi Chorus",
  "block.minecraft.clay": "Efere",
  "block.minecraft.closed_eyeblossom": "Closed Eyeblossom",
  "block.minecraft.coal_block": "Ihe mgbochi nke Kol",
  "block.minecraft.coal_ore": "Coal Ore",
  "block.minecraft.coarse_dirt": "Onu Unyi",
  "block.minecraft.cobbled_deepslate": "Cobled miri emi nkume",
  "block.minecraft.cobbled_deepslate_slab": "Cobled miri emi nkume mbadamba",
  "block.minecraft.cobbled_deepslate_stairs": "Cobled miri emi nkume steepụ",
  "block.minecraft.cobbled_deepslate_wall": "Mgbidi Deepslate Cobbled",
  "block.minecraft.cobblestone": "Nkịtị",
  "block.minecraft.cobblestone_slab": "Okpokoro Nkume",
  "block.minecraft.cobblestone_stairs": "Ulo Cobblestone",
  "block.minecraft.cobblestone_wall": "Nkume Nkume",
  "block.minecraft.cobweb": "Cobweb",
  "block.minecraft.cocoa": "Koko",
  "block.minecraft.command_block": "Iwu Block",
  "block.minecraft.comparator": "Onye na-achota Nkume",
  "block.minecraft.composter": "Ngwakọta",
  "block.minecraft.conduit": "Ndiniime",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "Ngọngọ ọla kọpa",
  "block.minecraft.copper_bulb": "Copper Bulb",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "Copper Door",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Copper Grate",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "Ọla kọpa",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "Copper Trapdoor",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "Ọka",
  "block.minecraft.cracked_deepslate_bricks": "Brik ndị gbara ọkpụrụkpụ",
  "block.minecraft.cracked_deepslate_tiles": "Taịlị Deepslate gbawara agbawa",
  "block.minecraft.cracked_nether_bricks": "Emerela Nether Brick",
  "block.minecraft.cracked_polished_blackstone_bricks": "Etu brọsh ojii ejirila ya mee",
  "block.minecraft.cracked_stone_bricks": "Nkume Nkume Gbawara",
  "block.minecraft.crafter": "Crafter",
  "block.minecraft.crafting_table": "Isiokwu Crafting",
  "block.minecraft.creaking_heart": "Creaking Heart",
  "block.minecraft.creeper_head": "Isi na-akpụ akpụ",
  "block.minecraft.creeper_wall_head": "Isi mgbidi Creeper",
  "block.minecraft.crimson_button": "Crimson bọtịnụ",
  "block.minecraft.crimson_door": "Crimson Door",
  "block.minecraft.crimson_fence": "Crimson Fence",
  "block.minecraft.crimson_fence_gate": "Crimson Fence Gate",
  "block.minecraft.crimson_fungus": "Crimson Fungus",
  "block.minecraft.crimson_hanging_sign": "Crimson Hanging Sign",
  "block.minecraft.crimson_hyphae": "Crimson Hyphae",
  "block.minecraft.crimson_nylium": "Crimson Nylium",
  "block.minecraft.crimson_planks": "Crimson Planks",
  "block.minecraft.crimson_pressure_plate": "Crimson nrụgide Plate",
  "block.minecraft.crimson_roots": "Crimson Roots",
  "block.minecraft.crimson_shelf": "Crimson Shelf",
  "block.minecraft.crimson_sign": "Crimson ịrịba ama",
  "block.minecraft.crimson_slab": "Crimson Slab",
  "block.minecraft.crimson_stairs": "Ọkpụkpụ Crimson",
  "block.minecraft.crimson_stem": "Crimson azuokokoosisi",
  "block.minecraft.crimson_trapdoor": "Crimson Trapdoor",
  "block.minecraft.crimson_wall_hanging_sign": "Crimson Wall Hanging Sign",
  "block.minecraft.crimson_wall_sign": "Crimson Wall Sign",
  "block.minecraft.crying_obsidian": "Ideidi Obsidian",
  "block.minecraft.cut_copper": "Bee ọla kọpa",
  "block.minecraft.cut_copper_slab": "Bee Okpokoro Ọla kọpa",
  "block.minecraft.cut_copper_stairs": "Bee steepụ ọla kọpa",
  "block.minecraft.cut_red_sandstone": "Bee Ucha Nkume",
  "block.minecraft.cut_red_sandstone_slab": "Bee Uhie Uhie",
  "block.minecraft.cut_sandstone": "Bee nkume isi",
  "block.minecraft.cut_sandstone_slab": "Bee nkume isi nkume",
  "block.minecraft.cyan_banner": "Banyere Cyan",
  "block.minecraft.cyan_bed": "Ndina Cyan",
  "block.minecraft.cyan_candle": "Kandụl cyan",
  "block.minecraft.cyan_candle_cake": "Achịcha na kandụl cyan",
  "block.minecraft.cyan_carpet": "Cyan Carpet",
  "block.minecraft.cyan_concrete": "Cyan Ihe",
  "block.minecraft.cyan_concrete_powder": "Cyan lhe Ntụ ntụ",
  "block.minecraft.cyan_glazed_terracotta": "Cyan na-egbuke egbuke Terracotta",
  "block.minecraft.cyan_shulker_box": "Igbe Cyan Shulker",
  "block.minecraft.cyan_stained_glass": "Iko Cyan",
  "block.minecraft.cyan_stained_glass_pane": "Cyan Stained Glass Pane",
  "block.minecraft.cyan_terracotta": "Cyan Terracotta",
  "block.minecraft.cyan_wool": "Nwa Cyan",
  "block.minecraft.damaged_anvil": "Anvil Mebiri",
  "block.minecraft.dandelion": "Dandelion",
  "block.minecraft.dark_oak_button": "Itiri Akpu Bọtịnụ",
  "block.minecraft.dark_oak_door": "Ọchịchịrị Oak",
  "block.minecraft.dark_oak_fence": "Ọchịchịrị Oak nsu",
  "block.minecraft.dark_oak_fence_gate": "Ọchịchịrị Oak nsu nsu",
  "block.minecraft.dark_oak_hanging_sign": "Dark Oak Hanging Sign",
  "block.minecraft.dark_oak_leaves": "Oak gbara ọchịchịrị",
  "block.minecraft.dark_oak_log": "Itiri Akpu Abanye",
  "block.minecraft.dark_oak_planks": "Itiri Akpu Atụmatụ",
  "block.minecraft.dark_oak_pressure_plate": "Itiri Akpu Okpokoro",
  "block.minecraft.dark_oak_sapling": "Ọchịchịrị Oak Sapling",
  "block.minecraft.dark_oak_shelf": "Dark Oak Shelf",
  "block.minecraft.dark_oak_sign": "Ọgba Ọchịchịrị Ọchịchịrị",
  "block.minecraft.dark_oak_slab": "Itiri Akpu Slab",
  "block.minecraft.dark_oak_stairs": "Itiri Akpu Nzọụkwụ",
  "block.minecraft.dark_oak_trapdoor": "Itiri Akpu Azuuzọ",
  "block.minecraft.dark_oak_wall_hanging_sign": "Dark Oak Wall Hanging Sign",
  "block.minecraft.dark_oak_wall_sign": "Ọchịchịrị Oak gbara ọchịchịrị",
  "block.minecraft.dark_oak_wood": "Osisi Oak gbara ọchịchịrị",
  "block.minecraft.dark_prismarine": "Ọchịchịrị Prismarine",
  "block.minecraft.dark_prismarine_slab": "Itiri Prismarine Slab",
  "block.minecraft.dark_prismarine_stairs": "Itiri Prismarine Nzọụkwụ",
  "block.minecraft.daylight_detector": "Onye nchọpụta ìhè",
  "block.minecraft.dead_brain_coral": "nwụrụ anwụ ụbụrụ coral",
  "block.minecraft.dead_brain_coral_block": "Ugbo nke coral oku ụbụrụ",
  "block.minecraft.dead_brain_coral_fan": "Brain Nkume coral nwụrụ anwụ",
  "block.minecraft.dead_brain_coral_wall_fan": "Nwụrụ Anwụ Brain Coral Wall Fan",
  "block.minecraft.dead_bubble_coral": "Nwụrụ Anwụ Afọ Coral ",
  "block.minecraft.dead_bubble_coral_block": "Ugbo nke coral oku egosipụta",
  "block.minecraft.dead_bubble_coral_fan": "Ọnwụ Afọ Coral Fan",
  "block.minecraft.dead_bubble_coral_wall_fan": "Nwụrụ anwụrụ Afụ Coral Wall Fan",
  "block.minecraft.dead_bush": "Bush anwụ anwụ",
  "block.minecraft.dead_fire_coral": "Coral Nwụrụ Anwụ nwụrụ",
  "block.minecraft.dead_fire_coral_block": "Ugbo nke coral oku ọkụ",
  "block.minecraft.dead_fire_coral_fan": "Nwụrụ Anwụ Ọkụ Nkume coral",
  "block.minecraft.dead_fire_coral_wall_fan": "Nwụrụ Anwụ Fire Coral Wall Fan",
  "block.minecraft.dead_horn_coral": "Coral nwụrụ anwụ nwụrụ",
  "block.minecraft.dead_horn_coral_block": "Ugbo nke coral oku nwere mpi",
  "block.minecraft.dead_horn_coral_fan": "Agụụ Mpi Coral ofufe",
  "block.minecraft.dead_horn_coral_wall_fan": "Agụụ Horn Coral Wall Fan",
  "block.minecraft.dead_tube_coral": "Coral nwụrụ anwụ nwụrụ",
  "block.minecraft.dead_tube_coral_block": "Ugbo nke coral tubular",
  "block.minecraft.dead_tube_coral_fan": "Nwụrụ Anwụ tube Nkume coral",
  "block.minecraft.dead_tube_coral_wall_fan": "Nwụrụ Anwụ tube Coral Wall Fan",
  "block.minecraft.decorated_pot": "Decorated Pot",
  "block.minecraft.deepslate": "Okwute miri emi",
  "block.minecraft.deepslate_brick_slab": "Mbadamba nkume brik",
  "block.minecraft.deepslate_brick_stairs": "Deepslate Brick steepụ",
  "block.minecraft.deepslate_brick_wall": "Mgbidi brik dị omimi",
  "block.minecraft.deepslate_bricks": "Brik ndị gbara ọkpụrụkpụ",
  "block.minecraft.deepslate_coal_ore": "Ngwurugwu ọla kọpa",
  "block.minecraft.deepslate_copper_ore": "Deepslate Ọla kọpa",
  "block.minecraft.deepslate_diamond_ore": "Deepslate ọla edo",
  "block.minecraft.deepslate_emerald_ore": "Okwute miri emi emerald ore",
  "block.minecraft.deepslate_gold_ore": "Igbochi. minecraft. okwa_nwachukwu_nke",
  "block.minecraft.deepslate_iron_ore": "Igbochi. minecraft. okwa_nwagbara",
  "block.minecraft.deepslate_lapis_ore": "Okwute miri emi lapis lazuli ore",
  "block.minecraft.deepslate_redstone_ore": "Deepslate Redstone Ore",
  "block.minecraft.deepslate_tile_slab": "Mbadamba Tile nke Deepslate",
  "block.minecraft.deepslate_tile_stairs": "Akwa steepụ dị omimi",
  "block.minecraft.deepslate_tile_wall": "Mgbidi Ngidi Deepslate",
  "block.minecraft.deepslate_tiles": "Taịlị Deepslate",
  "block.minecraft.detector_rail": "Zọ nchọpụta Detector",
  "block.minecraft.diamond_block": "Ngọngọ nke Diamond",
  "block.minecraft.diamond_ore": "Diamond Ore",
  "block.minecraft.diorite": "Diorite",
  "block.minecraft.diorite_slab": "Diorite slab",
  "block.minecraft.diorite_stairs": "Diorite steepụ",
  "block.minecraft.diorite_wall": "Mgbidi Diorite",
  "block.minecraft.dirt": "Unyi",
  "block.minecraft.dirt_path": "Ụzọ unyi",
  "block.minecraft.dispenser": "Dispensin",
  "block.minecraft.dragon_egg": "Akwa Egg",
  "block.minecraft.dragon_head": "Isi dragọn",
  "block.minecraft.dragon_wall_head": "Isi mgbidi Dragon",
  "block.minecraft.dried_ghast": "Dried Ghast",
  "block.minecraft.dried_kelp_block": "Mịrị Kelp mgbochi",
  "block.minecraft.dripstone_block": "Oghere Dripstone",
  "block.minecraft.dropper": "Tụlee",
  "block.minecraft.emerald_block": "Ngọngọ nke Emerald",
  "block.minecraft.emerald_ore": "Emerald Ore",
  "block.minecraft.enchanting_table": "Otu Tebụl",
  "block.minecraft.end_gateway": "Ọnụ ụzọ nke ọgwụgwụ",
  "block.minecraft.end_portal": "Ntinye Ọgwụgwụ",
  "block.minecraft.end_portal_frame": "Njedebe Portal Ọgwụgwụ",
  "block.minecraft.end_rod": "Ngwụcha Mkpanaka",
  "block.minecraft.end_stone": "Ọgwụgwụ Nkume",
  "block.minecraft.end_stone_brick_slab": "End Stone brik slab",
  "block.minecraft.end_stone_brick_stairs": "End Stone brik steepụ",
  "block.minecraft.end_stone_brick_wall": "Ọgwụgwụ Nkume Mgbidi brik",
  "block.minecraft.end_stone_bricks": "Ọgwụgwụ Nkume brik",
  "block.minecraft.ender_chest": "Ender Igbe",
  "block.minecraft.exposed_chiseled_copper": "Exposed Chiseled Copper",
  "block.minecraft.exposed_copper": "Ọla kọpa kpughere",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Exposed Copper Bulb",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Exposed Copper Door",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Exposed Copper Grate",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Exposed Copper Trapdoor",
  "block.minecraft.exposed_cut_copper": "Ekpughere Ọla kọpa",
  "block.minecraft.exposed_cut_copper_slab": "Egosipụtara Cut Okpokoro Ọla kọpa",
  "block.minecraft.exposed_cut_copper_stairs": "Egosipụtara Cut steepụ ọla kọpa",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Ala oru ubi",
  "block.minecraft.fern": "Fern",
  "block.minecraft.fire": "Ọkụ",
  "block.minecraft.fire_coral": "Coral ọkụ",
  "block.minecraft.fire_coral_block": "Oghere nke coral ọkụ",
  "block.minecraft.fire_coral_fan": "A na-enwe coral ọkụ",
  "block.minecraft.fire_coral_wall_fan": "Fire Coral Mgbidi Fan",
  "block.minecraft.firefly_bush": "Firefly Bush",
  "block.minecraft.fletching_table": "Isiokwu Fletching",
  "block.minecraft.flower_pot": "Ite ifuru",
  "block.minecraft.flowering_azalea": "Na-ama Azela",
  "block.minecraft.flowering_azalea_leaves": "Ifuru Azalea Ifuru",
  "block.minecraft.frogspawn": "Elespan",
  "block.minecraft.frosted_ice": "Frosted Ice",
  "block.minecraft.furnace": "Furnace",
  "block.minecraft.gilded_blackstone": "Nwa ojii gilded",
  "block.minecraft.glass": "Iko",
  "block.minecraft.glass_pane": "Ibu aja",
  "block.minecraft.glow_lichen": "Glow Lichen dị ọcha",
  "block.minecraft.glowstone": "Mkpụrụ Obi Sand",
  "block.minecraft.gold_block": "Ngọngọ nke Gold",
  "block.minecraft.gold_ore": "Gold ọlaedo",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Granite",
  "block.minecraft.granite_slab": "Granite slab",
  "block.minecraft.granite_stairs": "Granite steepụ",
  "block.minecraft.granite_wall": "Mgbidi Granite",
  "block.minecraft.grass": "Ahịhịa",
  "block.minecraft.grass_block": "Ogwe Ahịhịa",
  "block.minecraft.gravel": "Ajịrịjaja",
  "block.minecraft.gray_banner": "Agba ntụ Pụrụ Iche",
  "block.minecraft.gray_bed": "Agba ntụ Ndina",
  "block.minecraft.gray_candle": "Kandụl Grey",
  "block.minecraft.gray_candle_cake": "Achịcha na Gray Candle",
  "block.minecraft.gray_carpet": "Kapeeti agba ntụ",
  "block.minecraft.gray_concrete": "Agba ntụ lhe",
  "block.minecraft.gray_concrete_powder": "Agba ntụ lhe Ntụ ntụ",
  "block.minecraft.gray_glazed_terracotta": "Grey Glazed Terracotta",
  "block.minecraft.gray_shulker_box": "Igbe Grey Shulker",
  "block.minecraft.gray_stained_glass": "Iri na agba",
  "block.minecraft.gray_stained_glass_pane": "Grey stained Glass Pane",
  "block.minecraft.gray_terracotta": "Grey Terracotta",
  "block.minecraft.gray_wool": "Acha ajị anụ",
  "block.minecraft.green_banner": "Ọkọlọtọ Agba akwụkwọ ndụ",
  "block.minecraft.green_bed": "Ndina Agba akwụkwọ ndụ",
  "block.minecraft.green_candle": "Kandụl Green",
  "block.minecraft.green_candle_cake": "Achicha na Green kandụl",
  "block.minecraft.green_carpet": "Kapeeti Green",
  "block.minecraft.green_concrete": "Agba akwụkwọ ndụ Ihe",
  "block.minecraft.green_concrete_powder": "Agba akwụkwọ ndụ lhe Ntụ ntụ",
  "block.minecraft.green_glazed_terracotta": "Green gbara agba Terracotta",
  "block.minecraft.green_shulker_box": "Igbe Shulker Green",
  "block.minecraft.green_stained_glass": "Gilasi Green na-agba agba",
  "block.minecraft.green_stained_glass_pane": "Green kwadoro Glass ebi ndụ",
  "block.minecraft.green_terracotta": "Green Terracotta",
  "block.minecraft.green_wool": "Ajị anụ Green",
  "block.minecraft.grindstone": "Okpokoro",
  "block.minecraft.hanging_roots": "Mgbukpọ Eko",
  "block.minecraft.hay_block": "Hay Bọọlụ",
  "block.minecraft.heavy_core": "Heavy Core",
  "block.minecraft.heavy_weighted_pressure_plate": "Plate Predictive Ebu Arọ Juru",
  "block.minecraft.honey_block": "Gbochie Mmanụ a .ụ",
  "block.minecraft.honeycomb_block": "Ngọngọ mmanụ a Honeyụ",
  "block.minecraft.hopper": "Hopper",
  "block.minecraft.horn_coral": "Coral nwere mpi",
  "block.minecraft.horn_coral_block": "Ugbo nke coral oku nwere mpi",
  "block.minecraft.horn_coral_fan": "A na-enwe coral mpi",
  "block.minecraft.horn_coral_wall_fan": "Mpi Coral Mgbidi Fan",
  "block.minecraft.ice": "Plain Ice",
  "block.minecraft.infested_chiseled_stone_bricks": "Akpụ nkume a pịrị apị",
  "block.minecraft.infested_cobblestone": "Pavement Awara",
  "block.minecraft.infested_cracked_stone_bricks": "Akpụ nkume ndị gbawara agbawa",
  "block.minecraft.infested_deepslate": "Deepslate jupụtara",
  "block.minecraft.infested_mossy_stone_bricks": "Akpụ brik bred na-agagharị",
  "block.minecraft.infested_stone": "Nkume awara",
  "block.minecraft.infested_stone_bricks": "Akpụ brik na-agbazi",
  "block.minecraft.iron_bars": "Ogwe ígwè",
  "block.minecraft.iron_block": "Ngọngọ nke Iron",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "N'Ọnụ Ironzọ",
  "block.minecraft.iron_ore": "Ígwè ore",
  "block.minecraft.iron_trapdoor": "Tragwè Trapdoor",
  "block.minecraft.jack_o_lantern": "Jack o'Lantern",
  "block.minecraft.jigsaw": "Ngọngọ Jigsaw",
  "block.minecraft.jukebox": "Jukebox",
  "block.minecraft.jungle_button": "Ubi Bọtịnụ",
  "block.minecraft.jungle_door": "Ogige Jungle",
  "block.minecraft.jungle_fence": "Jungle ngere",
  "block.minecraft.jungle_fence_gate": "Ọnụ Fzọ encemá Ọhịa",
  "block.minecraft.jungle_hanging_sign": "Jungle Hanging Sign",
  "block.minecraft.jungle_leaves": "Oke Oke Osimiri",
  "block.minecraft.jungle_log": "Abanye na Ubi",
  "block.minecraft.jungle_planks": "Ubi Atụmatụ",
  "block.minecraft.jungle_pressure_plate": "Plate Strike Ubi",
  "block.minecraft.jungle_sapling": "Sapling Jungle",
  "block.minecraft.jungle_shelf": "Jungle Shelf",
  "block.minecraft.jungle_sign": "Nbanye Ala",
  "block.minecraft.jungle_slab": "Ubi Slab",
  "block.minecraft.jungle_stairs": "Ubi Nzọụkwụ",
  "block.minecraft.jungle_trapdoor": "Ohia Ahihia",
  "block.minecraft.jungle_wall_hanging_sign": "Jungle Wall Hanging Sign",
  "block.minecraft.jungle_wall_sign": "Ihe ịrịba ama nke Jungle",
  "block.minecraft.jungle_wood": "Osisi Jungle",
  "block.minecraft.kelp": "Kelp",
  "block.minecraft.kelp_plant": "Kelp Osisi",
  "block.minecraft.ladder": "Ladder",
  "block.minecraft.lantern": "Na-ejegharị",
  "block.minecraft.lapis_block": "Ihe mgbochi nke Lapis Lazuli",
  "block.minecraft.lapis_ore": "Lapis Lazuli Ore",
  "block.minecraft.large_amethyst_bud": "Nnukwu Amethyst Bud",
  "block.minecraft.large_fern": "Nnukwu Fern",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lava Cauldron",
  "block.minecraft.leaf_litter": "Leaf Litter",
  "block.minecraft.lectern": "Ozizi",
  "block.minecraft.lever": "Lever",
  "block.minecraft.light": "Mgbochi. minecraft. ọkụ",
  "block.minecraft.light_blue_banner": "Ìhè Bulu Pụrụ Iche",
  "block.minecraft.light_blue_bed": "Ìhè Bulu Ndina",
  "block.minecraft.light_blue_candle": "Light Blue kandụl",
  "block.minecraft.light_blue_candle_cake": "Achịcha na kandụl na -acha anụnụ anụnụ",
  "block.minecraft.light_blue_carpet": "Kapeeti Anụmanụ na-acha odo odo",
  "block.minecraft.light_blue_concrete": "Ìhè Blue lhe",
  "block.minecraft.light_blue_concrete_powder": "Ìhè Blue lhe Ntụ ntụ",
  "block.minecraft.light_blue_glazed_terracotta": "Magenta Glazed Terracotta",
  "block.minecraft.light_blue_shulker_box": "Ìhè Blue Shulker Igbe",
  "block.minecraft.light_blue_stained_glass": "Glass Lightined Glass",
  "block.minecraft.light_blue_stained_glass_pane": "Light Light stained Glass Pane",
  "block.minecraft.light_blue_terracotta": "Ìhè Blue Terracotta",
  "block.minecraft.light_blue_wool": "Uwe Blue Blue",
  "block.minecraft.light_gray_banner": "Ìhè Gray Pụrụ Iche",
  "block.minecraft.light_gray_bed": "Ìhè Agba ntụ Ndina",
  "block.minecraft.light_gray_candle": "Light Gray kandụl",
  "block.minecraft.light_gray_candle_cake": "Achịcha na kandụl ọkụ ọkụ",
  "block.minecraft.light_gray_carpet": "Carpet Light",
  "block.minecraft.light_gray_concrete": "Ìhè Agba Ihe",
  "block.minecraft.light_gray_concrete_powder": "Ìhè Agba hle Ntụ ntụ",
  "block.minecraft.light_gray_glazed_terracotta": "Ìhè Agba Glazed Terracotta",
  "block.minecraft.light_gray_shulker_box": "Ìhè Gray Shulker Igbe",
  "block.minecraft.light_gray_stained_glass": "Glass nke agba agba agba",
  "block.minecraft.light_gray_stained_glass_pane": "Light Grey stained Glass Pane",
  "block.minecraft.light_gray_terracotta": "Ìhè Gray Terracotta",
  "block.minecraft.light_gray_wool": "Ìhè Gray ajị",
  "block.minecraft.light_weighted_pressure_plate": "Plate Predictive Light",
  "block.minecraft.lightning_rod": "Mkpanaka ọkụ",
  "block.minecraft.lilac": "Lilac",
  "block.minecraft.lily_of_the_valley": "Lily nke ndagwurugwu",
  "block.minecraft.lily_pad": "Lily Kedo akwa",
  "block.minecraft.lime_banner": "Wayo Pụrụ Iche",
  "block.minecraft.lime_bed": "Wayo Ndina",
  "block.minecraft.lime_candle": "Wayo kandụl",
  "block.minecraft.lime_candle_cake": "Achịcha na kandụl Wayo",
  "block.minecraft.lime_carpet": "Wayo kapeeti",
  "block.minecraft.lime_concrete": "Oroma nkịrịsị Ihe",
  "block.minecraft.lime_concrete_powder": "Oroma nkịrịsị lhe Ntụ ntụ",
  "block.minecraft.lime_glazed_terracotta": "Wayo Glazed Terracotta",
  "block.minecraft.lime_shulker_box": "Wayo Shulker Igbe",
  "block.minecraft.lime_stained_glass": "Iko Lime Emechara",
  "block.minecraft.lime_stained_glass_pane": "Wayo Arụrụ Nọchiri Anya",
  "block.minecraft.lime_terracotta": "Wayo Terracotta",
  "block.minecraft.lime_wool": "Wayo ajị",
  "block.minecraft.lodestone": "Lodestone",
  "block.minecraft.loom": "Loom",
  "block.minecraft.magenta_banner": "Magenta Pụrụ Iche",
  "block.minecraft.magenta_bed": "Magenta Ndina",
  "block.minecraft.magenta_candle": "Kandụ Magenta",
  "block.minecraft.magenta_candle_cake": "Achịcha na kandụl Magenta",
  "block.minecraft.magenta_carpet": "Kapeeti Magenta",
  "block.minecraft.magenta_concrete": "Magenta lhu",
  "block.minecraft.magenta_concrete_powder": "Magenta lhe Ntụ ntụ",
  "block.minecraft.magenta_glazed_terracotta": "Magenta Glazed Terracotta",
  "block.minecraft.magenta_shulker_box": "Magenta Shulker Igbe",
  "block.minecraft.magenta_stained_glass": "Gilasi nke Magenta",
  "block.minecraft.magenta_stained_glass_pane": "Magenta akara egwuregwu",
  "block.minecraft.magenta_terracotta": "Magenta Terracotta",
  "block.minecraft.magenta_wool": "Magenta Wool",
  "block.minecraft.magma_block": "Magma Ngọngọ",
  "block.minecraft.mangrove_button": "Bọtịnụ Mangrove",
  "block.minecraft.mangrove_door": "Ọnụ ụzọ Mangrove",
  "block.minecraft.mangrove_fence": "Mgbidi nke Mangrove",
  "block.minecraft.mangrove_fence_gate": "Ọnụ ụzọ ngere Mangrove",
  "block.minecraft.mangrove_hanging_sign": "Mangrove Hanging Sign",
  "block.minecraft.mangrove_leaves": "Akwụkwọ osisi Mangrove",
  "block.minecraft.mangrove_log": "Akwụkwọ akụkọ Mangrove",
  "block.minecraft.mangrove_planks": "Osisi Mangrove",
  "block.minecraft.mangrove_pressure_plate": "Efere Nrụgide Mangrove",
  "block.minecraft.mangrove_propagule": "Mangrove Propagule",
  "block.minecraft.mangrove_roots": "Mgbọrọgwụ Mangrove",
  "block.minecraft.mangrove_shelf": "Mangrove Shelf",
  "block.minecraft.mangrove_sign": "Akara Mangrove",
  "block.minecraft.mangrove_slab": "Osisi Mangrove",
  "block.minecraft.mangrove_stairs": "Mangrove steepụ",
  "block.minecraft.mangrove_trapdoor": "Ọnụ ụzọ Mangrove",
  "block.minecraft.mangrove_wall_hanging_sign": "Mangrove Wall Hanging Sign",
  "block.minecraft.mangrove_wall_sign": "Akara mgbidi Mangrove",
  "block.minecraft.mangrove_wood": "Osisi Mangrove",
  "block.minecraft.medium_amethyst_bud": "Ọkara Amethyst Bud",
  "block.minecraft.melon": "Egwusi",
  "block.minecraft.melon_stem": "Ogwu Esiji",
  "block.minecraft.moss_block": "Akpaetu ngọngọ",
  "block.minecraft.moss_carpet": "Moss kapeeti",
  "block.minecraft.mossy_cobblestone": "Mossy Pavement",
  "block.minecraft.mossy_cobblestone_slab": "Mosis Cobblestone Slab",
  "block.minecraft.mossy_cobblestone_stairs": "Mossy Cobblestone steepụ",
  "block.minecraft.mossy_cobblestone_wall": "Mossy Cobblestone Mgbidi",
  "block.minecraft.mossy_stone_brick_slab": "Nkume Nkume Mosis Nkume",
  "block.minecraft.mossy_stone_brick_stairs": "Nkume Nkume Mosis Nkume",
  "block.minecraft.mossy_stone_brick_wall": "Nkume Nkume Mosis Nkume",
  "block.minecraft.mossy_stone_bricks": "Nkume Mossy Nkume",
  "block.minecraft.moving_piston": "Ogba Aghara Piston",
  "block.minecraft.mud": "Uro",
  "block.minecraft.mud_brick_slab": "Nri brik apịtị",
  "block.minecraft.mud_brick_stairs": "Ugboro steepụ brik",
  "block.minecraft.mud_brick_wall": "Mgbidi brik apịtị",
  "block.minecraft.mud_bricks": "Bricks apịtị",
  "block.minecraft.muddy_mangrove_roots": "Mgbọrọgwụ Mangrove Muddy",
  "block.minecraft.mushroom_stem": "Ero Nzuzo",
  "block.minecraft.mycelium": "Mycelium",
  "block.minecraft.nether_brick_fence": "Ogige Brick Nether",
  "block.minecraft.nether_brick_slab": "Nether Brick Slab",
  "block.minecraft.nether_brick_stairs": "Ebube Brick Nether",
  "block.minecraft.nether_brick_wall": "Neda Mgbidi brik",
  "block.minecraft.nether_bricks": "Nether Bricks",
  "block.minecraft.nether_gold_ore": "Nether Gold Ore",
  "block.minecraft.nether_portal": "Nether Portal",
  "block.minecraft.nether_quartz_ore": "Nduku",
  "block.minecraft.nether_sprouts": "Nkọwapụta Netherland",
  "block.minecraft.nether_wart": "Nether Wart",
  "block.minecraft.nether_wart_block": "Ebe Wart Block",
  "block.minecraft.netherite_block": "Ogwe nke Netherite",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Rịba ama Block",
  "block.minecraft.oak_button": "Akpu Bọtịnụ",
  "block.minecraft.oak_door": "Oak Orzọ",
  "block.minecraft.oak_fence": "Oak nsu",
  "block.minecraft.oak_fence_gate": "Ọnụ ụzọ ámá Oak",
  "block.minecraft.oak_hanging_sign": "Oak Hanging Sign",
  "block.minecraft.oak_leaves": "Oak doo",
  "block.minecraft.oak_log": "Akpu Abanye",
  "block.minecraft.oak_planks": "Akpu Atụmatụ",
  "block.minecraft.oak_pressure_plate": "Akpu Plate Stress",
  "block.minecraft.oak_sapling": "Oak Sapling",
  "block.minecraft.oak_shelf": "Oak Shelf",
  "block.minecraft.oak_sign": "Oak akara",
  "block.minecraft.oak_slab": "Akpu Slab",
  "block.minecraft.oak_stairs": "Akpu Nzọụkwụ",
  "block.minecraft.oak_trapdoor": "Akpu Azuuzọ",
  "block.minecraft.oak_wall_hanging_sign": "Oak Wall Hanging Sign",
  "block.minecraft.oak_wall_sign": "Oak Wall Sign",
  "block.minecraft.oak_wood": "Osisi Oak",
  "block.minecraft.observer": "Lụrụ",
  "block.minecraft.obsidian": "Obsidian",
  "block.minecraft.ochre_froglight": "Orche frogìhè",
  "block.minecraft.ominous_banner": "Akpata Pụrụ Iche",
  "block.minecraft.open_eyeblossom": "Open Eyeblossom",
  "block.minecraft.orange_banner": "Ọkọlọtọ oroma",
  "block.minecraft.orange_bed": "Ndina oroma",
  "block.minecraft.orange_candle": "Kandụl oroma",
  "block.minecraft.orange_candle_cake": "Achịcha na kandụl oroma",
  "block.minecraft.orange_carpet": "Kapeeti oroma",
  "block.minecraft.orange_concrete": "Oroma lhe ",
  "block.minecraft.orange_concrete_powder": "oroma lhe Ntụ ntụ",
  "block.minecraft.orange_glazed_terracotta": "Oroma Glazed Terracotta",
  "block.minecraft.orange_shulker_box": "Igbe oroma Shulker",
  "block.minecraft.orange_stained_glass": "Iko na agba oroma",
  "block.minecraft.orange_stained_glass_pane": "Glass Pane Oroma",
  "block.minecraft.orange_terracotta": "Orange Terracotta",
  "block.minecraft.orange_tulip": "Oroma Tulip",
  "block.minecraft.orange_wool": "Oroma Oroma",
  "block.minecraft.oxeye_daisy": "Oxeye Daisy",
  "block.minecraft.oxidized_chiseled_copper": "Oxidized Chiseled Copper",
  "block.minecraft.oxidized_copper": "Ọla kọpa Oxidized",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Oxidized Copper Bulb",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Oxidized Copper Door",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Oxidized Copper Grate",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Oxidized Copper Trapdoor",
  "block.minecraft.oxidized_cut_copper": "Ọla kọpa Oxidized",
  "block.minecraft.oxidized_cut_copper_slab": "Okpukpo ọla kọpa a kpụrụ akpụ",
  "block.minecraft.oxidized_cut_copper_stairs": "Oxidized Bee ọla kọpa steepụ",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Packed Ice",
  "block.minecraft.packed_mud": "Mud juru n'ọnụ",
  "block.minecraft.pale_hanging_moss": "Pale Hanging Moss",
  "block.minecraft.pale_moss_block": "Pale Moss Block",
  "block.minecraft.pale_moss_carpet": "Pale Moss Carpet",
  "block.minecraft.pale_oak_button": "Pale Oak Button",
  "block.minecraft.pale_oak_door": "Pale Oak Door",
  "block.minecraft.pale_oak_fence": "Pale Oak Fence",
  "block.minecraft.pale_oak_fence_gate": "Pale Oak Fence Gate",
  "block.minecraft.pale_oak_hanging_sign": "Pale Oak Hanging Sign",
  "block.minecraft.pale_oak_leaves": "Pale Oak Leaves",
  "block.minecraft.pale_oak_log": "Pale Oak Log",
  "block.minecraft.pale_oak_planks": "Pale Oak Planks",
  "block.minecraft.pale_oak_pressure_plate": "Pale Oak Pressure Plate",
  "block.minecraft.pale_oak_sapling": "Pale Oak Sapling",
  "block.minecraft.pale_oak_shelf": "Pale Oak Shelf",
  "block.minecraft.pale_oak_sign": "Pale Oak Sign",
  "block.minecraft.pale_oak_slab": "Pale Oak Slab",
  "block.minecraft.pale_oak_stairs": "Pale Oak Stairs",
  "block.minecraft.pale_oak_trapdoor": "Pale Oak Trapdoor",
  "block.minecraft.pale_oak_wall_hanging_sign": "Pale Oak Wall Hanging Sign",
  "block.minecraft.pale_oak_wall_sign": "Pale Oak Wall Sign",
  "block.minecraft.pale_oak_wood": "Pale Oak Wood",
  "block.minecraft.pearlescent_froglight": "Pearlescent ele ihè",
  "block.minecraft.peony": "Peony",
  "block.minecraft.petrified_oak_slab": "Na-ama jijiji Akpu Slab",
  "block.minecraft.piglin_head": "Piglin Head",
  "block.minecraft.piglin_wall_head": "Piglin Wall Head",
  "block.minecraft.pink_banner": "Pink Pụrụ Iche",
  "block.minecraft.pink_bed": "Pink Ndina",
  "block.minecraft.pink_candle": "Kandụl Pink",
  "block.minecraft.pink_candle_cake": "Achịcha na kandụl Pink",
  "block.minecraft.pink_carpet": "Kapeeti Pink",
  "block.minecraft.pink_concrete": "Pink Concrete lhe",
  "block.minecraft.pink_concrete_powder": "Pink lhe Ntụ ntụ",
  "block.minecraft.pink_glazed_terracotta": "Wayo Glazed Terracotta",
  "block.minecraft.pink_petals": "Pink Petals",
  "block.minecraft.pink_shulker_box": "Pink Shulker Igbe",
  "block.minecraft.pink_stained_glass": "Iri Anya isi Ala",
  "block.minecraft.pink_stained_glass_pane": "Pink Stained Glass Pane",
  "block.minecraft.pink_terracotta": "Pink Terracotta",
  "block.minecraft.pink_tulip": "Pink Tulip",
  "block.minecraft.pink_wool": "Pink ajị anụ",
  "block.minecraft.piston": "Pistin",
  "block.minecraft.piston_head": "Piston isi",
  "block.minecraft.pitcher_crop": "Pitcher Crop",
  "block.minecraft.pitcher_plant": "Pitcher Plant",
  "block.minecraft.player_head": "Isi player",
  "block.minecraft.player_head.named": "%s's Isi",
  "block.minecraft.player_wall_head": "Okpokoro player",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Akara Dripstone",
  "block.minecraft.polished_andesite": "Andesite a na-egbu egbu",
  "block.minecraft.polished_andesite_slab": "Nkume Polish Andesite",
  "block.minecraft.polished_andesite_stairs": "Ebube a na-egbu mara mma nke Andesite",
  "block.minecraft.polished_basalt": "Basalt Polured",
  "block.minecraft.polished_blackstone": "Nwa ojii",
  "block.minecraft.polished_blackstone_brick_slab": "Blackstone brick Slab",
  "block.minecraft.polished_blackstone_brick_stairs": "Ntọala Blackstone Brick",
  "block.minecraft.polished_blackstone_brick_wall": "Nnukwu mgbidi ojii",
  "block.minecraft.polished_blackstone_bricks": "Brik blọkụ ojii",
  "block.minecraft.polished_blackstone_button": "Mee bọtịnụ ojii",
  "block.minecraft.polished_blackstone_pressure_plate": "Ọkpụkpụ Ejiri Blackstone rụpụtara",
  "block.minecraft.polished_blackstone_slab": "Blackstone Slab",
  "block.minecraft.polished_blackstone_stairs": "Nzọ ọkwa Blackstone",
  "block.minecraft.polished_blackstone_wall": "Nnukwu ojii ojii",
  "block.minecraft.polished_deepslate": "Deepslate na -egbu maramara",
  "block.minecraft.polished_deepslate_slab": "Nkịtị Deepslate",
  "block.minecraft.polished_deepslate_stairs": "Steepụ Deepslate mara mma",
  "block.minecraft.polished_deepslate_wall": "Mgbidi Deepslate mara mma",
  "block.minecraft.polished_diorite": "Diorite gbagoro",
  "block.minecraft.polished_diorite_slab": "Egbu maramara Diorite slab",
  "block.minecraft.polished_diorite_stairs": "Ebube Diorite steepụ",
  "block.minecraft.polished_granite": "Granite mara mma",
  "block.minecraft.polished_granite_slab": "Ebube Granite Slab",
  "block.minecraft.polished_granite_stairs": "Ebube Granite steepụ",
  "block.minecraft.polished_tuff": "Polished Tuff",
  "block.minecraft.polished_tuff_slab": "Polished Tuff Slab",
  "block.minecraft.polished_tuff_stairs": "Polished Tuff Stairs",
  "block.minecraft.polished_tuff_wall": "Polished Tuff Wall",
  "block.minecraft.poppy": "Poppy",
  "block.minecraft.potatoes": "Nduku",
  "block.minecraft.potted_acacia_sapling": "Acacia na-amị mkpụrụ na ite",
  "block.minecraft.potted_allium": "Garlic n'ime ite",
  "block.minecraft.potted_azalea_bush": "Azalea gbara ọkpụrụkpụ",
  "block.minecraft.potted_azure_bluet": "Blue Houstonia n'ime ite",
  "block.minecraft.potted_bamboo": "Kpụrụ Achara",
  "block.minecraft.potted_birch_sapling": "Osisi ọka birch n'ime ite",
  "block.minecraft.potted_blue_orchid": "Blue orchid na ite",
  "block.minecraft.potted_brown_mushroom": "Aja aja toadstool n'ime ite",
  "block.minecraft.potted_cactus": "Cactus n'ime ite",
  "block.minecraft.potted_cherry_sapling": "Potted Cherry Sapling",
  "block.minecraft.potted_closed_eyeblossom": "Potted Closed Eyeblossom",
  "block.minecraft.potted_cornflower": "Kpụrụ Ọka",
  "block.minecraft.potted_crimson_fungus": "Potted Crimson Fungus",
  "block.minecraft.potted_crimson_roots": "Potted Crimson mgbọrọgwụ",
  "block.minecraft.potted_dandelion": "Dandelion n'ime ite",
  "block.minecraft.potted_dark_oak_sapling": "Okpu Oak seedling n'ime ite",
  "block.minecraft.potted_dead_bush": "Osisi a kpọrọ nkụ n'ime ite",
  "block.minecraft.potted_fern": "Buru n'ime ite",
  "block.minecraft.potted_flowering_azalea_bush": "Okooko osisi Azalea",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Ubi ahihia n'ime ite",
  "block.minecraft.potted_lily_of_the_valley": "Kpụrụ Lily nke Ndagwurugwu",
  "block.minecraft.potted_mangrove_propagule": "Osisi Mangrove Propagule",
  "block.minecraft.potted_oak_sapling": "Oak seedling n'ime ite",
  "block.minecraft.potted_open_eyeblossom": "Potted Open Eyeblossom",
  "block.minecraft.potted_orange_tulip": "Orange tulip n'ime ite",
  "block.minecraft.potted_oxeye_daisy": "Margaretka n'ime ite",
  "block.minecraft.potted_pale_oak_sapling": "Potted Pale Oak Sapling",
  "block.minecraft.potted_pink_tulip": "Pink tulip n'ime ite",
  "block.minecraft.potted_poppy": "Poppy n'ime ite",
  "block.minecraft.potted_red_mushroom": "Toadstool n'ime ite",
  "block.minecraft.potted_red_tulip": "Utu tulip n'ime ite",
  "block.minecraft.potted_spruce_sapling": "Ghaa mkpụrụ osisi na ite",
  "block.minecraft.potted_torchflower": "Potted Torchflower",
  "block.minecraft.potted_warped_fungus": "Fungus akpọrọ akpọ",
  "block.minecraft.potted_warped_roots": "Mgburugwu Akpọrọ akpụ",
  "block.minecraft.potted_white_tulip": "White tulip na ite",
  "block.minecraft.potted_wither_rose": "Kpụrụ Wither Rose",
  "block.minecraft.powder_snow": "Ntụ ntụ Snow",
  "block.minecraft.powder_snow_cauldron": "Ntụ ntụ Snow Cauldron",
  "block.minecraft.powered_rail": "Ilgbọ okporo ígwè kwadoro",
  "block.minecraft.prismarine": "Prismarine",
  "block.minecraft.prismarine_brick_slab": "Biriiki Prismarine Slab",
  "block.minecraft.prismarine_brick_stairs": "Biriiki Prismarine Nzọụkwụ",
  "block.minecraft.prismarine_bricks": "Brik Prismarine",
  "block.minecraft.prismarine_slab": "Prismarine Slab",
  "block.minecraft.prismarine_stairs": "Prismarine Nzọụkwụ",
  "block.minecraft.prismarine_wall": "Mgbidi Prismarine",
  "block.minecraft.pumpkin": "Ugu",
  "block.minecraft.pumpkin_stem": "Ugu azuokokoosisi",
  "block.minecraft.purple_banner": "Pụrụ Iche Pụrụ Iche",
  "block.minecraft.purple_bed": "Ndina Pọpụl",
  "block.minecraft.purple_candle": "Kandụl na -acha odo odo",
  "block.minecraft.purple_candle_cake": "Achicha na -acha odo odo kandụl",
  "block.minecraft.purple_carpet": "Purple Carpet",
  "block.minecraft.purple_concrete": "Pọpụl Ihe",
  "block.minecraft.purple_concrete_powder": "Pọpụl lhe Ntụ ntụ",
  "block.minecraft.purple_glazed_terracotta": "Pọpụl Glazed Terracotta",
  "block.minecraft.purple_shulker_box": "Igbe Purple Shulker",
  "block.minecraft.purple_stained_glass": "Iko Purple nke Nwere Ifuru",
  "block.minecraft.purple_stained_glass_pane": "Gululu nke Pụrụ Anya",
  "block.minecraft.purple_terracotta": "Pọpụl Terracotta",
  "block.minecraft.purple_wool": "Acha Purple",
  "block.minecraft.purpur_block": "Block Purpur",
  "block.minecraft.purpur_pillar": "Purpur Ogidi",
  "block.minecraft.purpur_slab": "Purpur slab",
  "block.minecraft.purpur_stairs": "Steepụ Purpur",
  "block.minecraft.quartz_block": "Ngọngọ nke Quartz",
  "block.minecraft.quartz_bricks": "Nkịtị Quartz",
  "block.minecraft.quartz_pillar": "Ogidi quartz",
  "block.minecraft.quartz_slab": "Quartz Slab",
  "block.minecraft.quartz_stairs": "Quartz steepụ",
  "block.minecraft.rail": "Ilzọ ụgbọ elu",
  "block.minecraft.raw_copper_block": "Ngọngọ nke ọla kọpa",
  "block.minecraft.raw_gold_block": "Ngọngọ nke ọla edo Raw",
  "block.minecraft.raw_iron_block": "Mkpọchi nke Irongwè",
  "block.minecraft.red_banner": "Uhie Pụrụ Iche",
  "block.minecraft.red_bed": "Ulo uhie",
  "block.minecraft.red_candle": "Kandụl uhie",
  "block.minecraft.red_candle_cake": "Achicha na Red kandụl",
  "block.minecraft.red_carpet": "Kapeeti Uhie",
  "block.minecraft.red_concrete": "uhie uhie ihe",
  "block.minecraft.red_concrete_powder": "Uhie lhe Ntụ ntụ",
  "block.minecraft.red_glazed_terracotta": "Green gbara agba Terracotta",
  "block.minecraft.red_mushroom": "Toadstool",
  "block.minecraft.red_mushroom_block": "Red Ero Mgbochi",
  "block.minecraft.red_nether_brick_slab": "Uhie uhie Nether Brick Slab",
  "block.minecraft.red_nether_brick_stairs": "Uhie Uhie brik",
  "block.minecraft.red_nether_brick_wall": "Uhie Mgbidi brik Neda",
  "block.minecraft.red_nether_bricks": "Brick Red Nether",
  "block.minecraft.red_sand": "Uhie uhie",
  "block.minecraft.red_sandstone": "Red Sandstone",
  "block.minecraft.red_sandstone_slab": "Nkume Red Sandstone",
  "block.minecraft.red_sandstone_stairs": "Uhie Red Sandstone",
  "block.minecraft.red_sandstone_wall": "Red Sandstone Mgbidi",
  "block.minecraft.red_shulker_box": "Red Shulker Igbe",
  "block.minecraft.red_stained_glass": "Iko Uhie na-acha uhie uhie",
  "block.minecraft.red_stained_glass_pane": "Uhie Glass Kwadoro",
  "block.minecraft.red_terracotta": "Uhie Terracotta",
  "block.minecraft.red_tulip": "Uhie Tulip",
  "block.minecraft.red_wool": "Uhie uwe anụ",
  "block.minecraft.redstone_block": "Ngọngọ nke Emerald",
  "block.minecraft.redstone_lamp": "Redstone Oriọna",
  "block.minecraft.redstone_ore": "Redstone Ore",
  "block.minecraft.redstone_torch": "Osimiri Redstone",
  "block.minecraft.redstone_wall_torch": "Uhie Redstone Mgbidi",
  "block.minecraft.redstone_wire": "Redstone Waya",
  "block.minecraft.reinforced_deepslate": "Deepslate jupụtara",
  "block.minecraft.repeater": "Nkume Tinyegharịa",
  "block.minecraft.repeating_command_block": "Ikwugharị Block iwu",
  "block.minecraft.resin_block": "Block of Resin",
  "block.minecraft.resin_brick_slab": "Resin Brick Slab",
  "block.minecraft.resin_brick_stairs": "Resin Brick Stairs",
  "block.minecraft.resin_brick_wall": "Resin Brick Wall",
  "block.minecraft.resin_bricks": "Resin Bricks",
  "block.minecraft.resin_clump": "Resin Clump",
  "block.minecraft.respawn_anchor": "Mpempe Respawn",
  "block.minecraft.rooted_dirt": "Unyi gbanyere mkpọrọgwụ",
  "block.minecraft.rose_bush": "Rose Bush",
  "block.minecraft.sand": "Aja",
  "block.minecraft.sandstone": "Nkume aja",
  "block.minecraft.sandstone_slab": "Okwute Sandstone",
  "block.minecraft.sandstone_stairs": "Ulo Sandstone",
  "block.minecraft.sandstone_wall": "Nkume Mgbidi",
  "block.minecraft.scaffolding": "Ibeghari ihu",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Ọkpụkpọ anụ",
  "block.minecraft.sculk_sensor": "Sensọ Sculk",
  "block.minecraft.sculk_shrieker": "Sculk Shrieker",
  "block.minecraft.sculk_vein": "Ọkpụkpụ akwara",
  "block.minecraft.sea_lantern": "Osisi Osisi",
  "block.minecraft.sea_pickle": "Oké Pikulu",
  "block.minecraft.seagrass": "Oké Ahịhịa",
  "block.minecraft.set_spawn": "Ntọala nrụpụta",
  "block.minecraft.short_dry_grass": "Short Dry Grass",
  "block.minecraft.short_grass": "Short Grass",
  "block.minecraft.shroomlight": "Ìhè",
  "block.minecraft.shulker_box": "Igbe Shulker",
  "block.minecraft.skeleton_skull": "Ọkpụkpụ okpokoro isi",
  "block.minecraft.skeleton_wall_skull": "Okpokoro skeleton",
  "block.minecraft.slime_block": "Mpempe slime",
  "block.minecraft.small_amethyst_bud": "Obere amethyst Bud",
  "block.minecraft.small_dripleaf": "Obere Dripleaf",
  "block.minecraft.smithing_table": "Isiokwu Smithing",
  "block.minecraft.smoker": "Anwụrụ anwụrụ",
  "block.minecraft.smooth_basalt": "Basalt dị nro",
  "block.minecraft.smooth_quartz": "Gbochie Quartz dị nro",
  "block.minecraft.smooth_quartz_slab": "Ezigbo Quartz Slab",
  "block.minecraft.smooth_quartz_stairs": "Ezigbo Quartz steepụ",
  "block.minecraft.smooth_red_sandstone": "Ezigbo Red Sandstone",
  "block.minecraft.smooth_red_sandstone_slab": "Ezigbo uhie uhie Sandstone Slab",
  "block.minecraft.smooth_red_sandstone_stairs": "Ezigbo Red Sandstone steepụ",
  "block.minecraft.smooth_sandstone": "Ezigbo Sandstone",
  "block.minecraft.smooth_sandstone_slab": "Ezigbo Sandstone Slab",
  "block.minecraft.smooth_sandstone_stairs": "Ezigbo Sandstone steepụ",
  "block.minecraft.smooth_stone": "Ezigbo Okute",
  "block.minecraft.smooth_stone_slab": "Nkume Na-agba Ọcha",
  "block.minecraft.sniffer_egg": "Sniffer Egg",
  "block.minecraft.snow": "Snoo",
  "block.minecraft.snow_block": "Ugbo snow",
  "block.minecraft.soul_campfire": "Mkpụrụ Obi Campfire",
  "block.minecraft.soul_fire": "Mkpụrụ Obi Ọkụ",
  "block.minecraft.soul_lantern": "Mkpụrụ Obi",
  "block.minecraft.soul_sand": "Mkpụrụ Obi Sand",
  "block.minecraft.soul_soil": "Mkpụrụ Obi",
  "block.minecraft.soul_torch": "Mkpụrụ Obi Torch",
  "block.minecraft.soul_wall_torch": "Mkpụrụ Obi Wall Torch",
  "block.minecraft.spawn.not_valid": "Enweghị akwa akwa ma ọ bụ ebubo arịgo arịlịka, ma ọ bụ gbochie ya",
  "block.minecraft.spawner": "Monster Spawner",
  "block.minecraft.spawner.desc1": "Interact with Spawn Egg:",
  "block.minecraft.spawner.desc2": "Sets Mob Type",
  "block.minecraft.sponge": "Ogbo",
  "block.minecraft.spore_blossom": "Okooko osisi",
  "block.minecraft.spruce_button": "Spruce Bọtịnụ",
  "block.minecraft.spruce_door": "Spruce n'Ọnụ",
  "block.minecraft.spruce_fence": "Ogige Spruce",
  "block.minecraft.spruce_fence_gate": "Spruce nsu nsu",
  "block.minecraft.spruce_hanging_sign": "Spruce Hanging Sign",
  "block.minecraft.spruce_leaves": "Spruce Ahapụ",
  "block.minecraft.spruce_log": "Abanye na Spruce",
  "block.minecraft.spruce_planks": "Ekepu Atụmatụ",
  "block.minecraft.spruce_pressure_plate": "Mpempe akwụkwọ Mgbochi",
  "block.minecraft.spruce_sapling": "spruce sapling",
  "block.minecraft.spruce_shelf": "Spruce Shelf",
  "block.minecraft.spruce_sign": "Ntughari ihe",
  "block.minecraft.spruce_slab": "Ekepu Slab",
  "block.minecraft.spruce_stairs": "Ekepu Nzọụkwụ",
  "block.minecraft.spruce_trapdoor": "Ekepu Ahihia",
  "block.minecraft.spruce_wall_hanging_sign": "Spruce Wall Hanging Sign",
  "block.minecraft.spruce_wall_sign": "Ihe ngosi Wall Spruce",
  "block.minecraft.spruce_wood": "Spruce Osisi",
  "block.minecraft.sticky_piston": "Nkwụnye pistin",
  "block.minecraft.stone": "Nkume",
  "block.minecraft.stone_brick_slab": "Biriiki Okute Slab",
  "block.minecraft.stone_brick_stairs": "Nkume Nkume Nkume",
  "block.minecraft.stone_brick_wall": "Nkume Nkume Nkume",
  "block.minecraft.stone_bricks": "Nkume brik",
  "block.minecraft.stone_button": "Nkume Bọtịnụ",
  "block.minecraft.stone_pressure_plate": "Nkume Nrụgide Nkume",
  "block.minecraft.stone_slab": "Nkume Nkume",
  "block.minecraft.stone_stairs": "Nkume steepụ",
  "block.minecraft.stonecutter": "Nkume okwute",
  "block.minecraft.stripped_acacia_log": "Akwụsịla Acacia Abanye",
  "block.minecraft.stripped_acacia_wood": "Akwụsịla Itiri Akpu Osisi",
  "block.minecraft.stripped_bamboo_block": "Block of Stripped Bamboo",
  "block.minecraft.stripped_birch_log": "Akwụsịla Birch Abanye",
  "block.minecraft.stripped_birch_wood": "Akwụsịla Brich Osisi",
  "block.minecraft.stripped_cherry_log": "Stripped Cherry Log",
  "block.minecraft.stripped_cherry_wood": "Stripped Cherry Wood",
  "block.minecraft.stripped_crimson_hyphae": "Stickened Crimson Hyphae",
  "block.minecraft.stripped_crimson_stem": "Tie Crimson Steeti",
  "block.minecraft.stripped_dark_oak_log": "Akwụsịla Itiri Akpu Abanye",
  "block.minecraft.stripped_dark_oak_wood": "Akwụsịla Itiri Akpu Osisi",
  "block.minecraft.stripped_jungle_log": "Akwụsịla Nnukwu Ohia Abanye",
  "block.minecraft.stripped_jungle_wood": "Akwụsịla Nnukwu Ohia Osisi",
  "block.minecraft.stripped_mangrove_log": "Ihe ndekọ Mangrove gbawara agbawa",
  "block.minecraft.stripped_mangrove_wood": "Osisi Mangrove gbawara agbawa",
  "block.minecraft.stripped_oak_log": "Akwụsịla Akpu Abanye",
  "block.minecraft.stripped_oak_wood": "Akwụsịla Akpu Osisi",
  "block.minecraft.stripped_pale_oak_log": "Stripped Pale Oak Log",
  "block.minecraft.stripped_pale_oak_wood": "Stripped Pale Oak Wood",
  "block.minecraft.stripped_spruce_log": "Akwụsịla Ekepu Abanye",
  "block.minecraft.stripped_spruce_wood": "Akwụsịla Ekepu Osisi",
  "block.minecraft.stripped_warped_hyphae": "Hypae Stpedted Warped",
  "block.minecraft.stripped_warped_stem": "Pedzọ Gbara Ọgbọ Afọ",
  "block.minecraft.structure_block": "Nhazi usoro",
  "block.minecraft.structure_void": "Nhazi abaghị uru",
  "block.minecraft.sugar_cane": "Okpete",
  "block.minecraft.sunflower": "Sunflower",
  "block.minecraft.suspicious_gravel": "Suspicious Gravel",
  "block.minecraft.suspicious_sand": "Suspicious Sand",
  "block.minecraft.sweet_berry_bush": "Bertọ Berry Ohia",
  "block.minecraft.tall_dry_grass": "Tall Dry Grass",
  "block.minecraft.tall_grass": "Ogologo Ahịhịa",
  "block.minecraft.tall_seagrass": "Ogologo Oké Ahịhịa",
  "block.minecraft.target": "Ezubere",
  "block.minecraft.terracotta": "Terracotta",
  "block.minecraft.test_block": "Test Block",
  "block.minecraft.test_instance_block": "Test Instance Block",
  "block.minecraft.tinted_glass": "Iko a tụrụ atụ",
  "block.minecraft.tnt": "Dynamite",
  "block.minecraft.tnt.disabled": "TNT explosions are disabled",
  "block.minecraft.torch": "Ọwa",
  "block.minecraft.torchflower": "Torchflower",
  "block.minecraft.torchflower_crop": "Torchflower Crop",
  "block.minecraft.trapped_chest": "Chest tọrọ atọ",
  "block.minecraft.trial_spawner": "Trial Spawner",
  "block.minecraft.tripwire": "Njem",
  "block.minecraft.tripwire_hook": "Nko nke Tripwire",
  "block.minecraft.tube_coral": "Coral tubular",
  "block.minecraft.tube_coral_block": "Oghere nke coral tubular",
  "block.minecraft.tube_coral_fan": "A na-enwe coral tubular",
  "block.minecraft.tube_coral_wall_fan": "Mgbidi Fan Coral tub",
  "block.minecraft.tuff": "Tuff",
  "block.minecraft.tuff_brick_slab": "Tuff Brick Slab",
  "block.minecraft.tuff_brick_stairs": "Tuff Brick Stairs",
  "block.minecraft.tuff_brick_wall": "Tuff Brick Wall",
  "block.minecraft.tuff_bricks": "Tuff Bricks",
  "block.minecraft.tuff_slab": "Tuff Slab",
  "block.minecraft.tuff_stairs": "Tuff Stairs",
  "block.minecraft.tuff_wall": "Tuff Wall",
  "block.minecraft.turtle_egg": "Mbe Egg",
  "block.minecraft.twisting_vines": "Vine Twist",
  "block.minecraft.twisting_vines_plant": "Osisi vaịn Na-agbagọ",
  "block.minecraft.vault": "Vault",
  "block.minecraft.verdant_froglight": "Verdant frogìhé",
  "block.minecraft.vine": "Vine",
  "block.minecraft.void_air": "Agụụ ikuku",
  "block.minecraft.wall_torch": "Mgbidi Uhie",
  "block.minecraft.warped_button": "Bọtị Warped",
  "block.minecraft.warped_door": "Ọnụ ụzọ Alụ ọgụ",
  "block.minecraft.warped_fence": "Nsu agha kpụ ọkụ n'ọnụ",
  "block.minecraft.warped_fence_gate": "Ọnụ ụzọ Fence",
  "block.minecraft.warped_fungus": "Fungus nke gbachara agbacha",
  "block.minecraft.warped_hanging_sign": "Warped Hanging Sign",
  "block.minecraft.warped_hyphae": "Hypae a lụrụ agha",
  "block.minecraft.warped_nylium": "Nylium anwụọ",
  "block.minecraft.warped_planks": "Planks Warped",
  "block.minecraft.warped_pressure_plate": "Gburugburu Nrụgide Arụ",
  "block.minecraft.warped_roots": "Mgbada Ọgụ",
  "block.minecraft.warped_shelf": "Warped Shelf",
  "block.minecraft.warped_sign": "Warped Sign",
  "block.minecraft.warped_slab": "Slab agha",
  "block.minecraft.warped_stairs": "Nrịba Egwuregwu",
  "block.minecraft.warped_stem": "Azuokokoosisi\n",
  "block.minecraft.warped_trapdoor": "Plọ njem dị warara",
  "block.minecraft.warped_wall_hanging_sign": "Warped Wall Hanging Sign",
  "block.minecraft.warped_wall_sign": "Ihe Nrịbaama Ama Ama",
  "block.minecraft.warped_wart_block": "Ngọngọ nke Wart",
  "block.minecraft.water": "Mmiri",
  "block.minecraft.water_cauldron": "Mmiri Cauldron",
  "block.minecraft.waxed_chiseled_copper": "Waxed Chiseled Copper",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Ihe mkpuchi ọla kọpa",
  "block.minecraft.waxed_copper_bulb": "Waxed Copper Bulb",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Waxed Copper Door",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Waxed Copper Grate",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Waxed Copper Trapdoor",
  "block.minecraft.waxed_cut_copper": "Ihe mkpuchi ọla kọpa",
  "block.minecraft.waxed_cut_copper_slab": "Waxed Cut ọla kọpa",
  "block.minecraft.waxed_cut_copper_stairs": "Waxed Cut Copper steepụ",
  "block.minecraft.waxed_exposed_chiseled_copper": "Waxed Exposed Chiseled Copper",
  "block.minecraft.waxed_exposed_copper": "Ọla kọpa e kpughere ekpuchi",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Waxed Exposed Copper Bulb",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Waxed Exposed Copper Door",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Waxed Exposed Copper Grate",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Waxed Exposed Copper Trapdoor",
  "block.minecraft.waxed_exposed_cut_copper": "Ihe mkpuchi ọla kọpa ekpughere",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Akpukpo ahu ekpughere nkedo ọla kọpa",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Ihe mkpuchi a kpachapụrụ agbachapụ steepụ ọla kọpa",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Waxed Oxidized Chiseled Copper",
  "block.minecraft.waxed_oxidized_copper": "Ọla kọpa a kpụrụ akpụ",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Waxed Oxidized Copper Bulb",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Waxed Oxidized Copper Door",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Waxed Oxidized Copper Grate",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Waxed Oxidized Copper Trapdoor",
  "block.minecraft.waxed_oxidized_cut_copper": "Waksị oxidized cot coper",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Waxed Oxidized Bee ọla kọpa",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Waxed Oxidized Bee steepụ ọla kọpa",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Waxed Weathered Chiseled Copper",
  "block.minecraft.waxed_weathered_copper": "Ọla kọpa a kpụrụ akpụ",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Waxed Weathered Copper Bulb",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Waxed Weathered Copper Door",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Waxed Weathered Copper Grate",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Waxed Weathered Copper Trapdoor",
  "block.minecraft.waxed_weathered_cut_copper": "Waksị Weathered Cut Copper",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Waxed Weathered Cut Cut Copper Slab",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Waxed Weathered Cut Cut Copper steepụ",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Weathered Chiseled Copper",
  "block.minecraft.weathered_copper": "Ọla kọpa Weathered",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Weathered Copper Bulb",
  "block.minecraft.weathered_copper_chain": "Weathered Copper Chain",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Weathered Copper Door",
  "block.minecraft.weathered_copper_golem_statue": "Weathered Copper Golem Statue",
  "block.minecraft.weathered_copper_grate": "Weathered Copper Grate",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Weathered Copper Trapdoor",
  "block.minecraft.weathered_cut_copper": "Ọla kọpa Weathered",
  "block.minecraft.weathered_cut_copper_slab": "Egosipụtara Cut Okpokoro Ọla kọpa",
  "block.minecraft.weathered_cut_copper_stairs": "Okpokoro ọla kọpa wepụrụ",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Ikwa Vine",
  "block.minecraft.weeping_vines_plant": "Osisi Iri osisi",
  "block.minecraft.wet_sponge": "Wet Wet",
  "block.minecraft.wheat": "Okpokoro Ugbo",
  "block.minecraft.white_banner": "Ọkọlọtọ Na-acha ọcha",
  "block.minecraft.white_bed": "Ihe ndina ọcha",
  "block.minecraft.white_candle": "Kandụl Ọcha",
  "block.minecraft.white_candle_cake": "Achicha na White kandụl",
  "block.minecraft.white_carpet": "White kapeeti",
  "block.minecraft.white_concrete": "Na-acha ọcha Ihe",
  "block.minecraft.white_concrete_powder": "Na-acha ọcha lhe Ntụ ntụ",
  "block.minecraft.white_glazed_terracotta": "White gbara agba Terracotta",
  "block.minecraft.white_shulker_box": "Igbe White Shulker",
  "block.minecraft.white_stained_glass": "Iko na-acha ọcha",
  "block.minecraft.white_stained_glass_pane": "Agba ntụpọ",
  "block.minecraft.white_terracotta": "White Terracotta",
  "block.minecraft.white_tulip": "Na-acha ọcha Tulip",
  "block.minecraft.white_wool": "White ajị",
  "block.minecraft.wildflowers": "Wildflowers",
  "block.minecraft.wither_rose": "Wither Rose",
  "block.minecraft.wither_skeleton_skull": "Okpokoro Isi Ọkpụkpụ okpokoro isi",
  "block.minecraft.wither_skeleton_wall_skull": "Okpokoro wither skeleton",
  "block.minecraft.yellow_banner": "Ọkọlọtọ Edo-edo",
  "block.minecraft.yellow_bed": "Ihe ndina edo edo",
  "block.minecraft.yellow_candle": "Kandụl na -acha odo odo",
  "block.minecraft.yellow_candle_cake": "Achịcha na kandụl odo",
  "block.minecraft.yellow_carpet": "Kapeeti edo edo",
  "block.minecraft.yellow_concrete": "Edo-edo lhe",
  "block.minecraft.yellow_concrete_powder": "Edo-edo lhe Ntụ ntụ",
  "block.minecraft.yellow_glazed_terracotta": "Yellow Glazed Terracotta",
  "block.minecraft.yellow_shulker_box": "Igbe Igbe Shulker",
  "block.minecraft.yellow_stained_glass": "Gilasi odo acha odo",
  "block.minecraft.yellow_stained_glass_pane": "Agba ntụpọ Yellow",
  "block.minecraft.yellow_terracotta": "Edo-edo Terracotta",
  "block.minecraft.yellow_wool": "Ajị anụ edo edo",
  "block.minecraft.zombie_head": "Isi Zombie",
  "block.minecraft.zombie_wall_head": "Okpokoro zombie",
  "item.minecraft.acacia_boat": "Atgbọ mmiri Acacia",
  "item.minecraft.acacia_chest_boat": "Ugbọ mmiri acacia na obi",
  "item.minecraft.allay_spawn_egg": "Akwa na-akpọ Allay",
  "item.minecraft.amethyst_shard": "Amethyst Shard",
  "item.minecraft.angler_pottery_shard": "Angler Pottery Shard",
  "item.minecraft.angler_pottery_sherd": "Angler Pottery Sherd",
  "item.minecraft.apple": "apụl",
  "item.minecraft.archer_pottery_shard": "Archer Pottery Shard",
  "item.minecraft.archer_pottery_sherd": "Archer Pottery Sherd",
  "item.minecraft.armadillo_scute": "Armadillo Scute",
  "item.minecraft.armadillo_spawn_egg": "Armadillo Spawn Egg",
  "item.minecraft.armor_stand": "Ekike agha Guzosie",
  "item.minecraft.arms_up_pottery_shard": "Arms Up Pottery Shard",
  "item.minecraft.arms_up_pottery_sherd": "Arms Up Pottery Sherd",
  "item.minecraft.arrow": "Ta",
  "item.minecraft.axolotl_bucket": "Bọketị nke Axolotl",
  "item.minecraft.axolotl_spawn_egg": "Axolotl Spawn Egg",
  "item.minecraft.baked_potato": "Nduku",
  "item.minecraft.bamboo_chest_raft": "Bamboo Raft with Chest",
  "item.minecraft.bamboo_raft": "Bamboo Raft",
  "item.minecraft.bat_spawn_egg": "Akwa na-akpọ bat",
  "item.minecraft.bee_spawn_egg": "Bee Spawn Egg",
  "item.minecraft.beef": "Anụ Nri",
  "item.minecraft.beetroot": "Anụmanụ",
  "item.minecraft.beetroot_seeds": "Mkpụrụ osisi Anụmanụ",
  "item.minecraft.beetroot_soup": "Anụmanụ Ofe",
  "item.minecraft.birch_boat": "Chgbọ mmiri Birch ",
  "item.minecraft.birch_chest_boat": "Ugbọ mmiri birch na obi",
  "item.minecraft.black_bundle": "Black Bundle",
  "item.minecraft.black_dye": "Nwa Agba",
  "item.minecraft.black_harness": "Black Harness",
  "item.minecraft.blade_pottery_shard": "Blade Pottery Shard",
  "item.minecraft.blade_pottery_sherd": "Blade Pottery Sherd",
  "item.minecraft.blaze_powder": "Ọkụ ntụ ntụ",
  "item.minecraft.blaze_rod": "Ọkụ ọkụ",
  "item.minecraft.blaze_spawn_egg": "Akwa na-akpọ Blaze",
  "item.minecraft.blue_bundle": "Blue Bundle",
  "item.minecraft.blue_dye": "Bulu Agba",
  "item.minecraft.blue_egg": "Blue Egg",
  "item.minecraft.blue_harness": "Blue Harness",
  "item.minecraft.bogged_spawn_egg": "Bogged Spawn Egg",
  "item.minecraft.bolt_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Bolt Armor Trim",
  "item.minecraft.bone": "Ọkpụkpụ",
  "item.minecraft.bone_meal": "Ọkpụkpụ Nri",
  "item.minecraft.book": "Akwụkwọ",
  "item.minecraft.bordure_indented_banner_pattern": "Bordure Indented Banner Pattern",
  "item.minecraft.bow": "Ta",
  "item.minecraft.bowl": "Bowl",
  "item.minecraft.bread": "Achịcha",
  "item.minecraft.breeze_rod": "Breeze Rod",
  "item.minecraft.breeze_spawn_egg": "Breeze Spawn Egg",
  "item.minecraft.brewer_pottery_shard": "Brewer Pottery Shard",
  "item.minecraft.brewer_pottery_sherd": "Brewer Pottery Sherd",
  "item.minecraft.brewing_stand": "Brewing Stand",
  "item.minecraft.brick": "Adobe",
  "item.minecraft.brown_bundle": "Brown Bundle",
  "item.minecraft.brown_dye": "Agba aja Agba",
  "item.minecraft.brown_egg": "Brown Egg",
  "item.minecraft.brown_harness": "Brown Harness",
  "item.minecraft.brush": "Brush",
  "item.minecraft.bucket": "Ịwụ",
  "item.minecraft.bundle": "Ibu",
  "item.minecraft.bundle.empty": "Empty",
  "item.minecraft.bundle.empty.description": "Can hold a mixed stack of items",
  "item.minecraft.bundle.full": "Full",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Burn Pottery Shard",
  "item.minecraft.burn_pottery_sherd": "Burn Pottery Sherd",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Camel Spawn Egg",
  "item.minecraft.carrot": "Karọt",
  "item.minecraft.carrot_on_a_stick": "Karọt na Mkpisi",
  "item.minecraft.cat_spawn_egg": "Nwambat ezigbo cakwa",
  "item.minecraft.cauldron": "Cauldron",
  "item.minecraft.cave_spider_spawn_egg": "Akwa na-akpọ oside ududo",
  "item.minecraft.chainmail_boots": "Akpụkpọ ụkwụ Chain",
  "item.minecraft.chainmail_chestplate": "Mgbochi obi Chain",
  "item.minecraft.chainmail_helmet": "Ihe nko ozi ikuku",
  "item.minecraft.chainmail_leggings": "Traụza Chain",
  "item.minecraft.charcoal": "Unyi",
  "item.minecraft.cherry_boat": "Cherry Boat",
  "item.minecraft.cherry_chest_boat": "Cherry Boat with Chest",
  "item.minecraft.chest_minecart": "Ngwongwo na Obi",
  "item.minecraft.chicken": "Ọkụkọ ọkụkọ",
  "item.minecraft.chicken_spawn_egg": "Akwa na-akpọ ọkpọ",
  "item.minecraft.chorus_fruit": "Mkpụrụ Korọs",
  "item.minecraft.clay_ball": "Bọọlụ Clay",
  "item.minecraft.clock": "Elekere",
  "item.minecraft.coal": "Kol",
  "item.minecraft.coast_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Coast Armor Trim",
  "item.minecraft.cocoa_beans": "Koko agwa",
  "item.minecraft.cod": "Cod esibeghi esi",
  "item.minecraft.cod_bucket": "Bucket na-emetụ usoro ntanetị",
  "item.minecraft.cod_spawn_egg": "Akwa na-akpọ usoro ntanetị",
  "item.minecraft.command_block_minecart": "Ngwongwo na Iwu Gbochie",
  "item.minecraft.compass": "Kompas",
  "item.minecraft.cooked_beef": "Ibe anụ",
  "item.minecraft.cooked_chicken": "Esie ya Ọkụkọ",
  "item.minecraft.cooked_cod": "Cod esiri esi",
  "item.minecraft.cooked_mutton": "Anụmanụ esiri esi",
  "item.minecraft.cooked_porkchop": "Ezi ụlọ esiri esi ",
  "item.minecraft.cooked_rabbit": "Oke oyibo",
  "item.minecraft.cooked_salmon": "Salmọn esiri esi",
  "item.minecraft.cookie": "Kuki",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Ọla kọpa Ingot",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Akwa na-akpọ Ehi",
  "item.minecraft.creaking_spawn_egg": "Creaking Spawn Egg",
  "item.minecraft.creeper_banner_pattern": "Nerkpụrụ Pụrụ Iche",
  "item.minecraft.creeper_banner_pattern.desc": "Ihe na-akpụ akpụ Nchaji",
  "item.minecraft.creeper_banner_pattern.new": "Creeper Charge Banner Pattern",
  "item.minecraft.creeper_spawn_egg": "Akwa na-akpọ Creeper",
  "item.minecraft.crossbow": "Obo",
  "item.minecraft.crossbow.projectile": "Ihe oru ngo:",
  "item.minecraft.crossbow.projectile.multiple": "Projectile: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projectile: %s",
  "item.minecraft.cyan_bundle": "Cyan Bundle",
  "item.minecraft.cyan_dye": "Cyan Agba",
  "item.minecraft.cyan_harness": "Cyan Harness",
  "item.minecraft.danger_pottery_shard": "Danger Pottery Shard",
  "item.minecraft.danger_pottery_sherd": "Danger Pottery Sherd",
  "item.minecraft.dark_oak_boat": "Ọchịchịrị akpu gbara ọchịchịrị",
  "item.minecraft.dark_oak_chest_boat": "Ọchịchịrị ugbọ mmiri oak na obi",
  "item.minecraft.debug_stick": "Osisi debug",
  "item.minecraft.debug_stick.empty": "%s enweghị ihe",
  "item.minecraft.debug_stick.select": "họrọ\"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" na %s",
  "item.minecraft.diamond": "Daimọn",
  "item.minecraft.diamond_axe": "Daimọn Ax",
  "item.minecraft.diamond_boots": "Daimọn akpụkpọ ụkwụ",
  "item.minecraft.diamond_chestplate": "Daimọn Chestplate",
  "item.minecraft.diamond_helmet": "Okpu aghaz Daimọn",
  "item.minecraft.diamond_hoe": "Daimọn Hoe",
  "item.minecraft.diamond_horse_armor": "Ebube Anyịnya Daimọn",
  "item.minecraft.diamond_leggings": "Leggọn Daimọn",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Daimọn Mkpa",
  "item.minecraft.diamond_shovel": "Daimọn shọvelụ",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Daimọn Mma agha",
  "item.minecraft.disc_fragment_5": "Mpekere diski",
  "item.minecraft.disc_fragment_5.desc": "Egwu Diski - 5",
  "item.minecraft.dolphin_spawn_egg": "Akwa na-akpọ Dolphin",
  "item.minecraft.donkey_spawn_egg": "Akwa na-akpọ Inyịnya Ibu",
  "item.minecraft.dragon_breath": "Ume Dragọn",
  "item.minecraft.dried_kelp": "Achịcha na-acha ahịhịa ndụ",
  "item.minecraft.drowned_spawn_egg": "Akwa na-akpọ Mmiri Mmiri",
  "item.minecraft.dune_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Dune Armor Trim",
  "item.minecraft.echo_shard": "Ikwughachi Shard",
  "item.minecraft.egg": "Akwa",
  "item.minecraft.elder_guardian_spawn_egg": "Akwa na-akpọ ndị Okenye Nche",
  "item.minecraft.elytra": "Elytra",
  "item.minecraft.emerald": "Emerald",
  "item.minecraft.enchanted_book": "Akwụkwọ enwasị",
  "item.minecraft.enchanted_golden_apple": "Apụl ọlaedo ekwukwasara okwu",
  "item.minecraft.end_crystal": "Kwụsị Crystal",
  "item.minecraft.ender_dragon_spawn_egg": "Ender Dragon Spawn Egg",
  "item.minecraft.ender_eye": "Anya nke Ender",
  "item.minecraft.ender_pearl": "Ender Ọla",
  "item.minecraft.enderman_spawn_egg": "Akwa na-akpọ Enderman",
  "item.minecraft.endermite_spawn_egg": "Akwa na-akpọ Endermite",
  "item.minecraft.evoker_spawn_egg": "Egg na-akpọ onye Na-akpọ Oku",
  "item.minecraft.experience_bottle": "Kalama ọ 'Na-adọrọ adọrọ",
  "item.minecraft.explorer_pottery_shard": "Explorer Pottery Shard",
  "item.minecraft.explorer_pottery_sherd": "Explorer Pottery Sherd",
  "item.minecraft.eye_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Eye Armor Trim",
  "item.minecraft.feather": "Nku",
  "item.minecraft.fermented_spider_eye": "N'egwuregwu Ududo Anya",
  "item.minecraft.field_masoned_banner_pattern": "Field Masoned Banner Pattern",
  "item.minecraft.filled_map": "Maapụ",
  "item.minecraft.fire_charge": "Ọkụ ọkụ",
  "item.minecraft.firework_rocket": "Igwe ọkụ ọkụ",
  "item.minecraft.firework_rocket.flight": "Oge lightgbọelu:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Igwe ọkụ ọkụ",
  "item.minecraft.firework_star.black": "Nwa",
  "item.minecraft.firework_star.blue": "Bulu",
  "item.minecraft.firework_star.brown": "Agba aja",
  "item.minecraft.firework_star.custom_color": "Custom",
  "item.minecraft.firework_star.cyan": "Cyan",
  "item.minecraft.firework_star.fade_to": "Jụ oyi na-",
  "item.minecraft.firework_star.flicker": "Twinkle\n",
  "item.minecraft.firework_star.gray": "Agba ntụ",
  "item.minecraft.firework_star.green": "Agba akwụkwọ ndụ",
  "item.minecraft.firework_star.light_blue": "Ìhè Bulu",
  "item.minecraft.firework_star.light_gray": "Ìhè Agba",
  "item.minecraft.firework_star.lime": "Oroma nkịrịsị",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "oroma",
  "item.minecraft.firework_star.pink": "Pink",
  "item.minecraft.firework_star.purple": "Pọpụl",
  "item.minecraft.firework_star.red": "Uhie",
  "item.minecraft.firework_star.shape": "Knowndị Amaghi",
  "item.minecraft.firework_star.shape.burst": "Gbawara",
  "item.minecraft.firework_star.shape.creeper": "Ihe na-akpụ akpụ-udi",
  "item.minecraft.firework_star.shape.large_ball": "Bọọlụ buru ibu",
  "item.minecraft.firework_star.shape.small_ball": "Obere Bọọlụ",
  "item.minecraft.firework_star.shape.star": "Ọdịdị kpakpando",
  "item.minecraft.firework_star.trail": "Nzọ ụkwụ",
  "item.minecraft.firework_star.white": "Na-acha ọcha",
  "item.minecraft.firework_star.yellow": "Edo-edo",
  "item.minecraft.fishing_rod": "Mkpanaka Azụ",
  "item.minecraft.flint": "Nkume",
  "item.minecraft.flint_and_steel": "Nkume na ígwè",
  "item.minecraft.flow_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Flow Armor Trim",
  "item.minecraft.flow_banner_pattern": "Banner Pattern",
  "item.minecraft.flow_banner_pattern.desc": "Flow",
  "item.minecraft.flow_banner_pattern.new": "Flow Banner Pattern",
  "item.minecraft.flow_pottery_sherd": "Flow Pottery Sherd",
  "item.minecraft.flower_banner_pattern": "Banner Pattern",
  "item.minecraft.flower_banner_pattern.desc": "Ifuru n'Aka",
  "item.minecraft.flower_banner_pattern.new": "Flower Charge Banner Pattern",
  "item.minecraft.flower_pot": "Flower Pot",
  "item.minecraft.fox_spawn_egg": "Nkịta ọhịa spawn akwa",
  "item.minecraft.friend_pottery_shard": "Friend Pottery Shard",
  "item.minecraft.friend_pottery_sherd": "Friend Pottery Sherd",
  "item.minecraft.frog_spawn_egg": "Akwa na-akpọ Ele",
  "item.minecraft.furnace_minecart": "Ngwongwo na Ọkụ",
  "item.minecraft.ghast_spawn_egg": "Akwa na-akpọ Ghast",
  "item.minecraft.ghast_tear": "Ghast Anya mmiri",
  "item.minecraft.glass_bottle": "Iko karama",
  "item.minecraft.glistering_melon_slice": "Iberi Egusi na-egbuke egbuke",
  "item.minecraft.globe_banner_pattern": "Banner Pattern",
  "item.minecraft.globe_banner_pattern.desc": "Ụwa",
  "item.minecraft.globe_banner_pattern.new": "Globe Banner Pattern",
  "item.minecraft.glow_berries": "Mkpụrụ osisi",
  "item.minecraft.glow_ink_sac": "Akpa Ink Glow",
  "item.minecraft.glow_item_frame": "Okpokoro Nkebi Dị Mkpa",
  "item.minecraft.glow_squid_spawn_egg": "Obere squid kpọọ akwa",
  "item.minecraft.glowstone_dust": "Nkume ọma ustjá",
  "item.minecraft.goat_horn": "Mpi Ewu",
  "item.minecraft.goat_spawn_egg": "Ewu Spawn Egg",
  "item.minecraft.gold_ingot": "Gold ọla",
  "item.minecraft.gold_nugget": "Ihe Ngwurugwu",
  "item.minecraft.golden_apple": "Apụl ọla edo ",
  "item.minecraft.golden_axe": "Axe ọla edo",
  "item.minecraft.golden_boots": "Akpụkpọ ụkwụ ọla edo",
  "item.minecraft.golden_carrot": "Karọt Ọlaedo",
  "item.minecraft.golden_chestplate": "Ihe nchekwa ọla edo ",
  "item.minecraft.golden_helmet": "Okpu-agha ọla edo",
  "item.minecraft.golden_hoe": "Ọha ọlaedo",
  "item.minecraft.golden_horse_armor": "Uwe agha ịnyịnya ọlaedo",
  "item.minecraft.golden_leggings": "Iwu ọla edo ",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Pickaxe ọlaedo",
  "item.minecraft.golden_shovel": "Shọvel ọla edo",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Mma agha ọla edo",
  "item.minecraft.gray_bundle": "Gray Bundle",
  "item.minecraft.gray_dye": "Agba ntụ",
  "item.minecraft.gray_harness": "Gray Harness",
  "item.minecraft.green_bundle": "Green Bundle",
  "item.minecraft.green_dye": "Agba akwụkwọ ndụ Agba",
  "item.minecraft.green_harness": "Green Harness",
  "item.minecraft.guardian_spawn_egg": "Akwa na-akpọ Onye Nche",
  "item.minecraft.gunpowder": "Egbe",
  "item.minecraft.guster_banner_pattern": "Banner Pattern",
  "item.minecraft.guster_banner_pattern.desc": "Guster",
  "item.minecraft.guster_banner_pattern.new": "Guster Banner Pattern",
  "item.minecraft.guster_pottery_sherd": "Guster Pottery Sherd",
  "item.minecraft.happy_ghast_spawn_egg": "Happy Ghast Spawn Egg",
  "item.minecraft.harness": "Harness",
  "item.minecraft.heart_of_the_sea": "Obi nke Oké Osimiri",
  "item.minecraft.heart_pottery_shard": "Heart Pottery Shard",
  "item.minecraft.heart_pottery_sherd": "Heart Pottery Sherd",
  "item.minecraft.heartbreak_pottery_shard": "Heartbreak Pottery Shard",
  "item.minecraft.heartbreak_pottery_sherd": "Heartbreak Pottery Sherd",
  "item.minecraft.hoglin_spawn_egg": "Hoglin Spawn Egg",
  "item.minecraft.honey_bottle": "Kalama mmanụ a .ụ",
  "item.minecraft.honeycomb": "Mmanụ a .ụ",
  "item.minecraft.hopper_minecart": "Ngwongwo na Hopper",
  "item.minecraft.horse_spawn_egg": "Akwa na-akpọ Ịnyịnya",
  "item.minecraft.host_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Howl Pottery Shard",
  "item.minecraft.howl_pottery_sherd": "Howl Pottery Sherd",
  "item.minecraft.husk_spawn_egg": "Akwa na-akpọ Husk",
  "item.minecraft.ink_sac": "Ink Nwa",
  "item.minecraft.iron_axe": "Axgwè Axe",
  "item.minecraft.iron_boots": "Bogwè akpụkpọ ụkwụ",
  "item.minecraft.iron_chestplate": "Ihe mkpuchi ígwè",
  "item.minecraft.iron_golem_spawn_egg": "Iron Golem Spawn Egg",
  "item.minecraft.iron_helmet": "Igwe Okpu-igwe",
  "item.minecraft.iron_hoe": "Hogwè Hoe",
  "item.minecraft.iron_horse_armor": "Horsnyịnya Ebube",
  "item.minecraft.iron_ingot": "Inggwè Ingot",
  "item.minecraft.iron_leggings": "Leggba Irongwè",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Ngwunye Irongwè",
  "item.minecraft.iron_pickaxe": "Pgwè Pickaxe",
  "item.minecraft.iron_shovel": "Shogwè shọvel",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Gwè Mma agha",
  "item.minecraft.item_frame": "Nkebi Ụba",
  "item.minecraft.jungle_boat": "Unggbọ mmiri nke Ọhịa",
  "item.minecraft.jungle_chest_boat": "Ụgbọ mmiri ọhịa nwere obi",
  "item.minecraft.knowledge_book": "Akwụkwọ Ihe Ọmụma",
  "item.minecraft.lapis_lazuli": "Lapis Lazuli",
  "item.minecraft.lava_bucket": "Lava ịwụ",
  "item.minecraft.lead": "Aha Kpido",
  "item.minecraft.leather": "Akpụkpọ anụ",
  "item.minecraft.leather_boots": "Akpụkpọ anụ akpụkpọ ụkwụ",
  "item.minecraft.leather_chestplate": "Akpụkpọ anụ Tunic",
  "item.minecraft.leather_helmet": "Akpụkpọ anụ okpu",
  "item.minecraft.leather_horse_armor": "Akpụkpọ anụ ịnyịnya Ekike agha",
  "item.minecraft.leather_leggings": "Akpụkpọ anụ akpụkpọ ụkwụ",
  "item.minecraft.light_blue_bundle": "Light Blue Bundle",
  "item.minecraft.light_blue_dye": "Ìhè Bulu Dai",
  "item.minecraft.light_blue_harness": "Light Blue Harness",
  "item.minecraft.light_gray_bundle": "Light Gray Bundle",
  "item.minecraft.light_gray_dye": "Ìhè Agba Agba",
  "item.minecraft.light_gray_harness": "Light Gray Harness",
  "item.minecraft.lime_bundle": "Lime Bundle",
  "item.minecraft.lime_dye": "Wayo dai",
  "item.minecraft.lime_harness": "Lime Harness",
  "item.minecraft.lingering_potion": "Na-egbu oge",
  "item.minecraft.lingering_potion.effect.awkward": "Nsogbu Na-adịghị Mma",
  "item.minecraft.lingering_potion.effect.empty": "Na-egbu oge",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Mgbatị Na-egbu Oge nke Nguzogide Ọkụ",
  "item.minecraft.lingering_potion.effect.harming": "Ogologo Oge Na-emebi",
  "item.minecraft.lingering_potion.effect.healing": "Oge Na-adịghị Anya nke Agwọ",
  "item.minecraft.lingering_potion.effect.infested": "Lingering Potion of Infestation",
  "item.minecraft.lingering_potion.effect.invisibility": "Oge Na-adịghị Anya nke Ahụghị Anya",
  "item.minecraft.lingering_potion.effect.leaping": "Ogologo oge nke ịgbapụ",
  "item.minecraft.lingering_potion.effect.levitation": "Na-egbu Oge Ime Levitị",
  "item.minecraft.lingering_potion.effect.luck": "Na-egbu Oge Ugwu",
  "item.minecraft.lingering_potion.effect.mundane": "Ebee Na-egbu oge Mgba",
  "item.minecraft.lingering_potion.effect.night_vision": "Oge Na-egbu Oge nke Ọhụụ Night",
  "item.minecraft.lingering_potion.effect.oozing": "Lingering Potion of Oozing",
  "item.minecraft.lingering_potion.effect.poison": "Oge Na-egbu Ahụ",
  "item.minecraft.lingering_potion.effect.regeneration": "Oge Na-egbu Oge",
  "item.minecraft.lingering_potion.effect.slow_falling": "Oge Na-egbu Oge nke Sda Ngwa",
  "item.minecraft.lingering_potion.effect.slowness": "Oge Na-egbu Oge",
  "item.minecraft.lingering_potion.effect.strength": "Ike Na-adịgide Adịgide",
  "item.minecraft.lingering_potion.effect.swiftness": "Oge Na-egbu Oge",
  "item.minecraft.lingering_potion.effect.thick": "Oké ingnọgide Ulo",
  "item.minecraft.lingering_potion.effect.turtle_master": "Oge Na-egbu Oge nke Nna-ukwu Agwa",
  "item.minecraft.lingering_potion.effect.water": "Agba Karama Mmiri",
  "item.minecraft.lingering_potion.effect.water_breathing": "Ogologo oge nke mmiri na-eku ume",
  "item.minecraft.lingering_potion.effect.weakness": "Na-egbu Oge",
  "item.minecraft.lingering_potion.effect.weaving": "Lingering Potion of Weaving",
  "item.minecraft.lingering_potion.effect.wind_charged": "Lingering Potion of Wind Charging",
  "item.minecraft.llama_spawn_egg": "Ntụgharị akwa lIama",
  "item.minecraft.lodestone_compass": "Lodestone kompas",
  "item.minecraft.mace": "Mace",
  "item.minecraft.magenta_bundle": "Magenta Bundle",
  "item.minecraft.magenta_dye": "Magenta dai",
  "item.minecraft.magenta_harness": "Magenta Harness",
  "item.minecraft.magma_cream": "Ude Magma",
  "item.minecraft.magma_cube_spawn_egg": "Egg na-akpọ Magma Cube",
  "item.minecraft.mangrove_boat": "Ụgbọ mmiri Mangrove",
  "item.minecraft.mangrove_chest_boat": "Ụgbọ mmiri Mangrove nwere obi",
  "item.minecraft.map": "Map efu",
  "item.minecraft.melon_seeds": "Mkpụrụ Mịlon",
  "item.minecraft.melon_slice": "Mberi egusi",
  "item.minecraft.milk_bucket": "Bụkeeti mmiri ara ehi",
  "item.minecraft.minecart": "Ngwongwo",
  "item.minecraft.miner_pottery_shard": "Miner Pottery Shard",
  "item.minecraft.miner_pottery_sherd": "Miner Pottery Sherd",
  "item.minecraft.mojang_banner_pattern": "Banner Pattern",
  "item.minecraft.mojang_banner_pattern.desc": "Ihe",
  "item.minecraft.mojang_banner_pattern.new": "Thing Banner Pattern",
  "item.minecraft.mooshroom_spawn_egg": "Akwa na-akpọ Toadstool",
  "item.minecraft.mourner_pottery_shard": "Mourner Pottery Shard",
  "item.minecraft.mourner_pottery_sherd": "Mourner Pottery Sherd",
  "item.minecraft.mule_spawn_egg": "Akwa na-akpọ Inyinya Mule",
  "item.minecraft.mushroom_stew": "Egwu Stew",
  "item.minecraft.music_disc_11": "Music Disc",
  "item.minecraft.music_disc_11.desc": "C418 --11",
  "item.minecraft.music_disc_13": "Egwu Diski",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Music Disc",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Music Disc",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Music Disc",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Music Disc",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Music Disc",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Music Disc",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Music Disc",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Music Disc",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Music Disc",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Music Disc",
  "item.minecraft.music_disc_mellohi.desc": "C418 -- mellohi",
  "item.minecraft.music_disc_otherside": "Music Disc",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Music Disc",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Music Disc",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Music Disc",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Music Disc",
  "item.minecraft.music_disc_stal.desc": "C418 - stolu",
  "item.minecraft.music_disc_strad": "Music Disc",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Music Disc",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Music Disc",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Music Disc",
  "item.minecraft.music_disc_ward.desc": "C418 - wọọdụ",
  "item.minecraft.mutton": "Raw Anụmanụ",
  "item.minecraft.name_tag": "Aha Kpido",
  "item.minecraft.nautilus_shell": "Nautilus shei",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Adobe brik",
  "item.minecraft.nether_star": "Neda Kpakpando",
  "item.minecraft.nether_wart": "Nether Wart",
  "item.minecraft.netherite_axe": "Axiteite Netherite",
  "item.minecraft.netherite_boots": "Boolu Netherite",
  "item.minecraft.netherite_chestplate": "Chestplate Netherite",
  "item.minecraft.netherite_helmet": "Helite Netherite",
  "item.minecraft.netherite_hoe": "Onye Hoe",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Netherite Ingot",
  "item.minecraft.netherite_leggings": "Legitings Netherite",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Pickaxe nke Netherland",
  "item.minecraft.netherite_scrap": "Scan Netherite",
  "item.minecraft.netherite_shovel": "Shoezaiteite",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Mma agha Netherite",
  "item.minecraft.netherite_upgrade_smithing_template": "Smithing Template",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Netherite Upgrade",
  "item.minecraft.oak_boat": "Oak ụgbọ mmiri",
  "item.minecraft.oak_chest_boat": "Ugbọ mmiri oak na obi",
  "item.minecraft.ocelot_spawn_egg": "Akwa na-akpọ Ocelot",
  "item.minecraft.ominous_bottle": "Ominous Bottle",
  "item.minecraft.ominous_trial_key": "Ominous Trial Key",
  "item.minecraft.orange_bundle": "Orange Bundle",
  "item.minecraft.orange_dye": "Oroma dai",
  "item.minecraft.orange_harness": "Orange Harness",
  "item.minecraft.painting": "Ihe osise",
  "item.minecraft.pale_oak_boat": "Pale Oak Boat",
  "item.minecraft.pale_oak_chest_boat": "Pale Oak Boat with Chest",
  "item.minecraft.panda_spawn_egg": "Panda spawn akwa",
  "item.minecraft.paper": "Akwụkwọ",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Akwa na-akpọ Okooko",
  "item.minecraft.phantom_membrane": "Phantom akpụkpọ",
  "item.minecraft.phantom_spawn_egg": "Akwa na-akpọ Uda",
  "item.minecraft.pig_spawn_egg": "Akwa na-akpọ Ezi",
  "item.minecraft.piglin_banner_pattern": "Banner Pattern",
  "item.minecraft.piglin_banner_pattern.desc": "Izu",
  "item.minecraft.piglin_banner_pattern.new": "Snout Banner Pattern",
  "item.minecraft.piglin_brute_spawn_egg": "Piglin Brute spawn akwa",
  "item.minecraft.piglin_spawn_egg": "Piglin Spawn Egg",
  "item.minecraft.pillager_spawn_egg": "Akwa akwa",
  "item.minecraft.pink_bundle": "Pink Bundle",
  "item.minecraft.pink_dye": "Pink agba",
  "item.minecraft.pink_harness": "Pink Harness",
  "item.minecraft.pitcher_plant": "Pitcher Plant",
  "item.minecraft.pitcher_pod": "Pitcher Pod",
  "item.minecraft.plenty_pottery_shard": "Plenty Pottery Shard",
  "item.minecraft.plenty_pottery_sherd": "Plenty Pottery Sherd",
  "item.minecraft.poisonous_potato": "Nsi na-egbu egbu",
  "item.minecraft.polar_bear_spawn_egg": "Akwa nke na-akpọ Okpọ Pola",
  "item.minecraft.popped_chorus_fruit": "Mkpụrụ osisi Korọs",
  "item.minecraft.porkchop": "Ezi ụlọ anụ ọhịa",
  "item.minecraft.potato": "Nduku",
  "item.minecraft.potion": "Ulo",
  "item.minecraft.potion.effect.awkward": "Nsogbu Ulo",
  "item.minecraft.potion.effect.empty": "Ugbo ala",
  "item.minecraft.potion.effect.fire_resistance": "Mgba nke Nguzogide Ọkụ",
  "item.minecraft.potion.effect.harming": "Mgba nke Imerụ Ahụ",
  "item.minecraft.potion.effect.healing": "Ulo Agwọ",
  "item.minecraft.potion.effect.infested": "Potion of Infestation",
  "item.minecraft.potion.effect.invisibility": "Mba nke Ahụghị Anya",
  "item.minecraft.potion.effect.leaping": "Ulo nke ịgba ọsọ",
  "item.minecraft.potion.effect.levitation": "Ulo nke Itationgba mbọ",
  "item.minecraft.potion.effect.luck": "Ndepụta nke Chioma",
  "item.minecraft.potion.effect.mundane": "Ebee Ulo",
  "item.minecraft.potion.effect.night_vision": "Ulo nke ọhụụ abalị",
  "item.minecraft.potion.effect.oozing": "Potion of Oozing",
  "item.minecraft.potion.effect.poison": "Ndepụta nke nsi",
  "item.minecraft.potion.effect.regeneration": "Ugba nke imu",
  "item.minecraft.potion.effect.slow_falling": "Ulo nke nwayọ nwayọ",
  "item.minecraft.potion.effect.slowness": "Ulo nke Udighi",
  "item.minecraft.potion.effect.strength": "Ikike nke Ike",
  "item.minecraft.potion.effect.swiftness": "Ududo nke Ọsọ",
  "item.minecraft.potion.effect.thick": "Oke osisi",
  "item.minecraft.potion.effect.turtle_master": "Uda nke Nna-ukwu mbe",
  "item.minecraft.potion.effect.water": "Kalama Mmiri",
  "item.minecraft.potion.effect.water_breathing": "Mpekere nke mmiri na-eku ume",
  "item.minecraft.potion.effect.weakness": "Mpempe adịghị ike",
  "item.minecraft.potion.effect.weaving": "Potion of Weaving",
  "item.minecraft.potion.effect.wind_charged": "Potion of Wind Charging",
  "item.minecraft.pottery_shard_archer": "Archer Pottery Shard",
  "item.minecraft.pottery_shard_arms_up": "Arms Up Pottery Shard",
  "item.minecraft.pottery_shard_prize": "Prize Pottery Shard",
  "item.minecraft.pottery_shard_skull": "Skull Pottery Shard",
  "item.minecraft.powder_snow_bucket": "Ịwụ Snow ịwụ",
  "item.minecraft.prismarine_crystals": "Kristal Prismarine",
  "item.minecraft.prismarine_shard": "Onyediegwu Prismarine",
  "item.minecraft.prize_pottery_shard": "Prize Pottery Shard",
  "item.minecraft.prize_pottery_sherd": "Prize Pottery Sherd",
  "item.minecraft.pufferfish": "Pufferfish",
  "item.minecraft.pufferfish_bucket": "Bọket nke Pufferfish",
  "item.minecraft.pufferfish_spawn_egg": "Akwa na-akpọ Onye Nwere Nsogbu",
  "item.minecraft.pumpkin_pie": "Ugu achịcha",
  "item.minecraft.pumpkin_seeds": "Mkpụrụ Mkpụrụ ugu",
  "item.minecraft.purple_bundle": "Purple Bundle",
  "item.minecraft.purple_dye": "Pọpụl dai",
  "item.minecraft.purple_harness": "Purple Harness",
  "item.minecraft.quartz": "Neda Quartz",
  "item.minecraft.rabbit": "Oke oyibo",
  "item.minecraft.rabbit_foot": "Kwụ kwụ",
  "item.minecraft.rabbit_hide": "Oke oyibo zoro",
  "item.minecraft.rabbit_spawn_egg": "Akwa na-akpọ Oke Bekee",
  "item.minecraft.rabbit_stew": "Oke oyibo",
  "item.minecraft.raiser_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Raiser Armor Trim",
  "item.minecraft.ravager_spawn_egg": "Akwa na agba egbe",
  "item.minecraft.raw_copper": "Ọla kọpa",
  "item.minecraft.raw_gold": "Ọla edo",
  "item.minecraft.raw_iron": "Iron dị ọcha",
  "item.minecraft.recovery_compass": "Kompas Mgbake",
  "item.minecraft.red_bundle": "Red Bundle",
  "item.minecraft.red_dye": "Uhie dai",
  "item.minecraft.red_harness": "Red Harness",
  "item.minecraft.redstone": "Nkume ustjá ",
  "item.minecraft.resin_brick": "Resin Brick",
  "item.minecraft.resin_clump": "Resin Clump",
  "item.minecraft.rib_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Rib Armor Trim",
  "item.minecraft.rotten_flesh": "Anụ Ahụ rere ere",
  "item.minecraft.saddle": "Sadulu",
  "item.minecraft.salmon": "Salmọn Raw",
  "item.minecraft.salmon_bucket": "Bucket na-emetụ Salmon",
  "item.minecraft.salmon_spawn_egg": "Akwa na-akpọ Maka Salmon",
  "item.minecraft.scrape_pottery_sherd": "Scrape Pottery Sherd",
  "item.minecraft.scute": "Scute",
  "item.minecraft.sentry_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Sentry Armor Trim",
  "item.minecraft.shaper_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Shaper Armor Trim",
  "item.minecraft.sheaf_pottery_shard": "Sheaf Pottery Shard",
  "item.minecraft.sheaf_pottery_sherd": "Sheaf Pottery Sherd",
  "item.minecraft.shears": "Kwa osisi",
  "item.minecraft.sheep_spawn_egg": "Akwa na-akpọ Atụrụ",
  "item.minecraft.shelter_pottery_shard": "Shelter Pottery Shard",
  "item.minecraft.shelter_pottery_sherd": "Shelter Pottery Sherd",
  "item.minecraft.shield": "Ọta",
  "item.minecraft.shield.black": "Ọta ojii",
  "item.minecraft.shield.blue": "Bulu Ọta",
  "item.minecraft.shield.brown": "Ọta Agba aja",
  "item.minecraft.shield.cyan": "Ọta Cyan",
  "item.minecraft.shield.gray": "Ọta Agba ntụ",
  "item.minecraft.shield.green": "Ọta Agba akwụkwọ ndụ",
  "item.minecraft.shield.light_blue": "Ìhè Bulu Ọta",
  "item.minecraft.shield.light_gray": "Ọkụ Agba ntụ Ọta",
  "item.minecraft.shield.lime": "Wayo Ọta",
  "item.minecraft.shield.magenta": "Ọta Magenta",
  "item.minecraft.shield.orange": "Ọta oroma",
  "item.minecraft.shield.pink": "Pink Ọta",
  "item.minecraft.shield.purple": "Ọta Pọpụl",
  "item.minecraft.shield.red": "Uhie Ọta",
  "item.minecraft.shield.white": "Ọta ọcha",
  "item.minecraft.shield.yellow": "Ọta Edo-edo",
  "item.minecraft.shulker_shell": "Onyekachi shei",
  "item.minecraft.shulker_spawn_egg": "Akwa na-akpọ Shulker",
  "item.minecraft.sign": "Sign",
  "item.minecraft.silence_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Silence Armor Trim",
  "item.minecraft.silverfish_spawn_egg": "Akwa na-akpọ Azụ Azụ",
  "item.minecraft.skeleton_horse_spawn_egg": "Akwa na-akpọ Okpụkpụ Ịnyịnya",
  "item.minecraft.skeleton_spawn_egg": "Achị na-akpọ Okpụkpụ",
  "item.minecraft.skull_banner_pattern": "Banner Pattern",
  "item.minecraft.skull_banner_pattern.desc": "Ebube okpokoro isi",
  "item.minecraft.skull_banner_pattern.new": "Skull Charge Banner Pattern",
  "item.minecraft.skull_pottery_shard": "Skull Pottery Shard",
  "item.minecraft.skull_pottery_sherd": "Skull Pottery Sherd",
  "item.minecraft.slime_ball": "Obere egwuregwu",
  "item.minecraft.slime_spawn_egg": "Akwa na-akpọ Sludge",
  "item.minecraft.smithing_template": "Smithing Template",
  "item.minecraft.smithing_template.applies_to": "Applies to:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Add ingot or crystal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armor",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Add a piece of armor",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Ingots & Crystals",
  "item.minecraft.smithing_template.ingredients": "Ingredients:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Add Netherite Ingot",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Diamond Equipment",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Add diamond armor, weapon, or tool",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Netherite Ingot",
  "item.minecraft.smithing_template.upgrade": "Upgrade: ",
  "item.minecraft.sniffer_spawn_egg": "Sniffer Spawn Egg",
  "item.minecraft.snort_pottery_shard": "Snort Pottery Shard",
  "item.minecraft.snort_pottery_sherd": "Snort Pottery Sherd",
  "item.minecraft.snout_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snout Armor Trim",
  "item.minecraft.snow_golem_spawn_egg": "Snow Golem Spawn Egg",
  "item.minecraft.snowball": "Snowball",
  "item.minecraft.spectral_arrow": "Akụkụ Spectral",
  "item.minecraft.spider_eye": "Anya ududo",
  "item.minecraft.spider_spawn_egg": "Akwa na-akpọ Ududo",
  "item.minecraft.spire_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Spire Armor Trim",
  "item.minecraft.splash_potion": "Mgbapu Mgbapu",
  "item.minecraft.splash_potion.effect.awkward": "Nsogbu na-adịghị mma",
  "item.minecraft.splash_potion.effect.empty": "Ikwommiri Apụghị Ulo",
  "item.minecraft.splash_potion.effect.fire_resistance": "Ikwommiri Ulo nke Ọkụ Nguzogide",
  "item.minecraft.splash_potion.effect.harming": "Mgbapu Mgbapụ nke Igwu",
  "item.minecraft.splash_potion.effect.healing": "Mgbapu Mgbapu nke Agwọ",
  "item.minecraft.splash_potion.effect.infested": "Splash Potion of Infestation",
  "item.minecraft.splash_potion.effect.invisibility": "Mgbapu Mgbapụ nke Ahụghị Anya",
  "item.minecraft.splash_potion.effect.leaping": "Mgbapu Mgbapụ nke Nwụpụ",
  "item.minecraft.splash_potion.effect.levitation": "Mgbapu Mgbapụ nke Levgba mbọ",
  "item.minecraft.splash_potion.effect.luck": "Mgbapu Mgbapu nke Luck",
  "item.minecraft.splash_potion.effect.mundane": "Ebee Ikwommiri Ulo",
  "item.minecraft.splash_potion.effect.night_vision": "Ikwommiri Ulo nke Night Night",
  "item.minecraft.splash_potion.effect.oozing": "Splash Potion of Oozing",
  "item.minecraft.splash_potion.effect.poison": "Mgbapu Mgba Ahụ",
  "item.minecraft.splash_potion.effect.regeneration": "Mgbapu Mgbapụta nke imu",
  "item.minecraft.splash_potion.effect.slow_falling": "Mgbapu Mgbapu nke nwayọ nwayọ",
  "item.minecraft.splash_potion.effect.slowness": "Mgbapu Mgbapụ nke Ume",
  "item.minecraft.splash_potion.effect.strength": "Mgbapu Mgbapu nke Ike",
  "item.minecraft.splash_potion.effect.swiftness": "Ikwommiri Ulo nke Ngwa ngwa",
  "item.minecraft.splash_potion.effect.thick": "Oke Mgbapu Mgbapu",
  "item.minecraft.splash_potion.effect.turtle_master": "Mgbapu Mgbapu nke Nna-ukwu Agwa",
  "item.minecraft.splash_potion.effect.water": "Igbapu mmiri kalama",
  "item.minecraft.splash_potion.effect.water_breathing": "Mgbapu Mmiri nke Mmiri Na-eku ume",
  "item.minecraft.splash_potion.effect.weakness": "Mgbapu Egwu nke Adịghị Ike",
  "item.minecraft.splash_potion.effect.weaving": "Splash Potion of Weaving",
  "item.minecraft.splash_potion.effect.wind_charged": "Splash Potion of Wind Charging",
  "item.minecraft.spruce_boat": "Rugbọ mmiri Spruce",
  "item.minecraft.spruce_chest_boat": "Spruce ụgbọ mmiri na obi",
  "item.minecraft.spyglass": "Spyglass",
  "item.minecraft.squid_spawn_egg": "Akwa na-akpọ Squid",
  "item.minecraft.stick": "Kọọ",
  "item.minecraft.stone_axe": "Nkume Ax",
  "item.minecraft.stone_hoe": "Nkume Nkume",
  "item.minecraft.stone_pickaxe": "Nkume Pickaxe",
  "item.minecraft.stone_shovel": "Nkume Nkume",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Nkume Nkume",
  "item.minecraft.stray_spawn_egg": "Akwa na-akpọ Wanderer",
  "item.minecraft.strider_spawn_egg": "Strider Spawn Egg",
  "item.minecraft.string": "Eriri",
  "item.minecraft.sugar": "Sugar\n\n",
  "item.minecraft.suspicious_stew": "Enyo enyo",
  "item.minecraft.sweet_berries": "Bertọ Tomato",
  "item.minecraft.tadpole_bucket": "Bucket na-emetụ Salmon",
  "item.minecraft.tadpole_spawn_egg": "Akwa na-akpọ Inyinya Tadpole",
  "item.minecraft.tide_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Tide Armor Trim",
  "item.minecraft.tipped_arrow": "Ntuziaka",
  "item.minecraft.tipped_arrow.effect.awkward": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.empty": "Ugboro Akwadoghị Aghara",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Akụ nke Nguzogide Ọkụ",
  "item.minecraft.tipped_arrow.effect.harming": "Akụ nke emebi",
  "item.minecraft.tipped_arrow.effect.healing": "Akụ nke ọgwụgwọ",
  "item.minecraft.tipped_arrow.effect.infested": "Arrow of Infestation",
  "item.minecraft.tipped_arrow.effect.invisibility": "Akụ nke Ahụghị Anya",
  "item.minecraft.tipped_arrow.effect.leaping": "Akụ nke ịwụ elu",
  "item.minecraft.tipped_arrow.effect.levitation": "Akụ nke Itationgba mbọ",
  "item.minecraft.tipped_arrow.effect.luck": "Akụ nke Chioma",
  "item.minecraft.tipped_arrow.effect.mundane": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.night_vision": "Akụ nke Abalị Abalị",
  "item.minecraft.tipped_arrow.effect.oozing": "Arrow of Oozing",
  "item.minecraft.tipped_arrow.effect.poison": "Akụ nke nsi",
  "item.minecraft.tipped_arrow.effect.regeneration": "Akụ nke imu",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Akụ nke ngwa ngwa ada",
  "item.minecraft.tipped_arrow.effect.slowness": "Akụ nke ngwa ngwa",
  "item.minecraft.tipped_arrow.effect.strength": "Akụ nke ike",
  "item.minecraft.tipped_arrow.effect.swiftness": "Akụ nke ngwa ngwa",
  "item.minecraft.tipped_arrow.effect.thick": "Tipped Arrow",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Akụ nke Nna-ukwu Nna-ukwu",
  "item.minecraft.tipped_arrow.effect.water": "Akụ nke Na-agbapụ",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Akụ nke mmiri iku ume",
  "item.minecraft.tipped_arrow.effect.weakness": "Akụ nke adịghị ike",
  "item.minecraft.tipped_arrow.effect.weaving": "Arrow of Weaving",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Arrow of Wind Charging",
  "item.minecraft.tnt_minecart": "Minecart na TNT",
  "item.minecraft.torchflower_seeds": "Torchflower Seeds",
  "item.minecraft.totem_of_undying": "Totem nke Ekwenye",
  "item.minecraft.trader_llama_spawn_egg": "Onye ahia Llama akwa akwa",
  "item.minecraft.trial_key": "Trial Key",
  "item.minecraft.trident": "Trident",
  "item.minecraft.tropical_fish": "Azụ dị ebe okpomọkụ",
  "item.minecraft.tropical_fish_bucket": "Bucket na-emetụ Azụ ebe okpomọkụ",
  "item.minecraft.tropical_fish_spawn_egg": "Akwa na-akpọ Azù Ebe Okpomọkụ",
  "item.minecraft.turtle_helmet": "Shei shei",
  "item.minecraft.turtle_scute": "Turtle Scute",
  "item.minecraft.turtle_spawn_egg": "Akwa na-akpọ Nnụnụ",
  "item.minecraft.vex_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Vex Armor Trim",
  "item.minecraft.vex_spawn_egg": "Akwa na-akpọ Onye Omekome Ahụ",
  "item.minecraft.villager_spawn_egg": "Akwa na-akpọ Obịa Ahụ",
  "item.minecraft.vindicator_spawn_egg": "Akwa na-akpọ Onye Nchebe",
  "item.minecraft.wandering_trader_spawn_egg": "Na-awagharị Onye ahia spawn akwa",
  "item.minecraft.ward_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ward Armor Trim",
  "item.minecraft.warden_spawn_egg": "Akwa na-akpọ Warden",
  "item.minecraft.warped_fungus_on_a_stick": "Fungus achara na osisi",
  "item.minecraft.water_bucket": "Buwụ mmiri",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Wayfinder Armor Trim",
  "item.minecraft.wheat": "Wheat",
  "item.minecraft.wheat_seeds": "Mkpụrụ ọka witi",
  "item.minecraft.white_bundle": "White Bundle",
  "item.minecraft.white_dye": "Na-acha ọcha dai",
  "item.minecraft.white_harness": "White Harness",
  "item.minecraft.wild_armor_trim_smithing_template": "Smithing Template",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Wild Armor Trim",
  "item.minecraft.wind_charge": "Wind Charge",
  "item.minecraft.witch_spawn_egg": "Akwa na-akpọ Onye Amoosu",
  "item.minecraft.wither_skeleton_spawn_egg": "Achị na-akpọ Wither Okpụkpụ",
  "item.minecraft.wither_spawn_egg": "Wither Spawn Egg",
  "item.minecraft.wolf_armor": "Wolf Armor",
  "item.minecraft.wolf_spawn_egg": "Akwa na-akpọ Anụ Ohịa Wolf",
  "item.minecraft.wooden_axe": "Osisi Ax",
  "item.minecraft.wooden_hoe": "Osisi Hoe",
  "item.minecraft.wooden_pickaxe": "Osisi Pickaxe",
  "item.minecraft.wooden_shovel": "Osisi Shọvelụ",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Mma agha",
  "item.minecraft.writable_book": "Akwụkwọ na njedebe",
  "item.minecraft.written_book": "Akwụkwọ ederede",
  "item.minecraft.yellow_bundle": "Yellow Bundle",
  "item.minecraft.yellow_dye": "Agba odo",
  "item.minecraft.yellow_harness": "Yellow Harness",
  "item.minecraft.zoglin_spawn_egg": "Akwa Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Akwa na-akpọ Zombie Ịnyịnya",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Akwa na-akpọ Zombie",
  "item.minecraft.zombie_villager_spawn_egg": "Akwa na-akpọ Zombie Obịa Ahụ",
  "item.minecraft.zombified_piglin_spawn_egg": "Zighara Piglin Spawn Egg"
}
export const ig_ng = items; 
